<template>
  <div class="q_main_content">
    <div class="q_content">
      <div class="pos">
        <div class="pos-topheader">
          <div class="pos-branding">
              <!-- <img class="pos-logo" src="/static/img/logo_blk_sm.png"> -->
              <span class="username">{{ cashierName }}</span>
          </div>
          <div class="pos-rightheader">
              <div class="order-selector">
                  <span class="orders touch-scrollable">                    
                      <span class="order-button select-order selected" data-uid="00001-001-0003">
                          <span class="order-sequence">
                              {{ sessionNo }}
                          </span>
                          {{ sessionTime }}
                      </span>                
                  </span>
                  <!-- <span class="order-button square neworder-button">
                      <i class="icon ion-plus"></i>
                  </span>
                  <span class="order-button square deleteorder-button">
                      <i class="icon ion-minus"></i>
                  </span> -->
              </div>

              <div class="oe_status js_synch">
                  <!-- <span class="js_msg oe_hidden"></span>
                  <div class="js_connected oe_icon oe_green">
                      <i class="icon ion-fw fa-wifi"></i>
                  </div>
                  <div class="js_connecting oe_icon oe_hidden">
                      <i class="icon ion-fw fa-spin fa-spinner"></i>
                  </div>
                  <div class="js_disconnected oe_icon oe_red oe_hidden">
                      <i class="icon ion-fw fa-wifi"></i>
                  </div>
                  <div class="js_error oe_icon oe_red oe_hidden">
                      <i class="icon ion-fw fa-warning"></i>
                  </div> -->
              </div>

              <div class="header-button" @click="onClose()">
                  Close
              </div>
          </div>
        </div>

        <div class="pos-content">
          <div class="window">
            <div class="subwindow">
              <div class="subwindow-container">
                <div class="subwindow-container-fix screens">                                
                  <div class="scale-screen screen oe_hidden">
                      <div class="screen-content">
                          <div class="top-content">
                              <span class="button back">
                                  <i class="icon ion-angle-double-left"></i>
                                  Back
                              </span>
                              <h1 class="product-name">Unnamed Product</h1>
                          </div>
                          <div class="centered-content">
                              <div class="weight js-weight">
                                  0.000 Kg
                              </div>
                              <div class="product-price">
                                  Rp 0.00/
                              </div>
                              <div class="computed-price">
                                  123.14 €
                              </div>
                              <div class="buy-product">
                                  Order
                                  <i class="icon ion-angle-double-right"></i>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="product-screen screen" v-if="viewType == VIEW_INITIAL">
                      <div class="leftpane">
                          <div class="window">
                              <div class="subwindow">
                                  <div class="subwindow-container">
                                      <div class="subwindow-container-fix">
                                          <div class="order-container">
                                              <div class="order-scroller touch-scrollable">
                                                  <div class="order">
                                                    <ul class="orderlines">
                                                      <li class="orderline" v-for="(row, i) in listCart" v-bind:key="i" @click="cartItemIndex = i" :class="{selected:cartItemIndex == i}">
                                                        <span class="product-name">{{ row.name }}</span>
                                                        <span class="price">{{ displayNumber(row.qty * row.price) }}</span>
                                                        <ul class="info-list">                                                                              
                                                          <li class="info">
                                                            <em>{{ displayNumber(row.qty) }}&nbsp;</em>{{ row.uom }} at {{ displayNumber(row.price) }}/{{ row.uom }}
                                                          </li>                                                                                                                                                            
                                                        </ul>
                                                      </li>
                                                    </ul>
                                                    <div class="summary clearfix" v-if="this.emptyCartStatus != EMPTY_CART">
                                                      <div class="line">
                                                        <div class="entry total">
                                                          <span class="label">Total: </span><span class="value">{{ totalAmount }}</span>
                                                          <div class="subentry">Taxes: <span class="value">{{ taxAmount }}</span></div>
                                                        </div>
                                                      </div>
                                                    </div>                                                                                                                                                                                                                        
                                                    <div class="order-empty" v-if="this.emptyCartStatus === EMPTY_CART">
                                                        <i class="icon ion-shopping-cart"></i>
                                                        <h1>Your shopping cart is empty</h1>
                                                    </div>                                                                                                                                                    
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="subwindow collapsed">
                                  <div class="subwindow-container">
                                      <div class="subwindow-container-fix pads">
                                          <div class="control-buttons oe_hidden">                                                                    
                                          </div>
                                          <div class="actionpad">
                                              <button class="button set-customer" @click="onDisplayScreenCustomer(viewType)">
                                                  <i class="icon ion-user"></i>                                                                                                                                                 
                                                  {{ customerSelectedName }}                                                                        
                                              </button>
                                              <button class="button pay" @click="onPayment()">
                                                  <div class="pay-circle">
                                                      <i class="icon ion-chevron-right"></i> 
                                                  </div>
                                                  Payment
                                              </button>
                                          </div>
                                          <div class="numpad">
                                              <button class="input-button number-char" @click="onClickNumpad('1')">1</button>
                                              <button class="input-button number-char" @click="onClickNumpad('2')">2</button>
                                              <button class="input-button number-char" @click="onClickNumpad('3')">3</button>
                                              <button class="mode-button selected-mode" @click="onClickNumpad('Qty')" data-mode="quantity">Qty</button>
                                              <br>
                                              <button class="input-button number-char" @click="onClickNumpad('4')">4</button>
                                              <button class="input-button number-char" @click="onClickNumpad('5')">5</button>
                                              <button class="input-button number-char" @click="onClickNumpad('6')">6</button>
                                              <button class="mode-button" data-mode="discount"></button>
                                              <br>
                                              <button class="input-button number-char" @click="onClickNumpad('7')">7</button>
                                              <button class="input-button number-char" @click="onClickNumpad('8')">8</button>
                                              <button class="input-button number-char" @click="onClickNumpad('9')">9</button>
                                              <button class="mode-button" data-mode="price"></button>
                                              <br>
                                              <button class="input-button numpad-minus"></button>
                                              <button class="input-button number-char" @click="onClickNumpad('0')">0</button>
                                              <button class="input-button number-char" @click="onClickNumpad(',')">,</button>
                                              <button class="input-button numpad-backspace" @click="onClickNumpad('BACKSPACE')">
                                                  <img height="21" src="/static/img/backspace.png" style="pointer-events: none;" width="24">
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="rightpane">
                          <table class="layout-table">
                              <tbody>
                                  <tr class="header-row">
                                      <td class="header-cell">
                                          <div>
                                              <header class="rightpane-header">
                                                  <div class="breadcrumbs">
                                                      <span class="breadcrumb-pos">
                                                          <span class="breadcrumb-button breadcrumb-home js-category-switch" @click="onDisplayScreenOrder(viewType)">
                                                             <i class="icon ion-printer"></i>
                                                          </span>
                                                      </span>
                                                      <span class="breadcrumb-pos">
                                                          <span class="breadcrumb-button breadcrumb-home js-category-switch" @click="onClickHomeBreadCrumb()">
                                                              <i class="icon ion-home"></i>
                                                          </span>
                                                      </span>
                                                      <span class="breadcrumb-pos" v-for="(row, i) in listBreadCrumb" v-bind:key="i">
                                                          <img class="breadcrumb-arrow" src="/static/img/bc-arrow-big.png">
                                                          <span class="breadcrumb-button js-category-switch" :data-category-id="row.id">
                                                              {{ row.name }}
                                                          </span>
                                                      </span>                                                                     
                                                  </div>
                                                  <div class="searchbox">
                                                      <input type="text" v-on:keyup.enter="onSearchProduct($event)" placeholder="Search Products">
                                                      <span class="search-clear"></span>
                                                  </div>
                                              </header>

                                              <div class="categories">
                                                  <div class="category-list-scroller touch-scrollable">
                                                      <div class="category-list simple">
                                                          <span v-for="(row, i) in listProductCategory" v-bind:key="i" class="category-simple-button js-category-switch" :data-category-id="row.id" @click="onClickProductCategory(row)">
                                                              {{ row.name }}
                                                          </span>
                                                      </div>
                                                  </div>
                                              </div>                                                            
                                          </div>
                                      </td>
                                  </tr>

                                  <tr class="content-row">
                                      <td class="content-cell">
                                          <div class="content-container">
                                              <div class="product-list-container">
                                                  <div class="product-list-scroller touch-scrollable">
                                                      <div class="product-list">
                                                          <span v-for="(row, i) in listProduct" v-bind:key="i" class="product" :data-product-id="row.id" @click="onSelectProduct(row)">
                                                              <div class="product-img">
                                                                  <img :src="'/image/Product/' + row.imageUrl">                                                                             
                                                                  <span class="price-tag">
                                                                      {{ row.currentPrice }}
                                                                  </span>                                                                                                                                                        
                                                              </div>
                                                              <div class="product-name">
                                                                  {{ row.name }}
                                                              </div>
                                                          </span>
                                                      </div>
                                                      <span class="placeholder-ScrollbarWidget"></span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>
                  <div class="clientlist-screen screen" v-if="viewType == VIEW_CUSTOMER">
                    <div class="screen-content">
                      <section class="top-content">
                          <span class="button back" @click="onBackCustomer()">
                              <i class="icon ion-angle-double-left"></i>
                              Cancel
                          </span>
                          <span class="searchbox">
                              <input type="text" v-on:keyup.enter="onSearchMember($event)" placeholder="Search Customers">
                              <span class="search-clear"></span>
                          </span>
                          <!-- <span class="searchbox"></span>
                          <span class="button new-customer">
                              <i class="icon ion-user"></i>
                              <i class="icon ion-plus"></i>
                          </span> -->
                          <span class="button next highlight" @click="onSetCustomer">{{ textButtonSetCustomer }}</span>
                      </section>
                      <section class="full-content">
                        <div class="window">
                          <section class="subwindow collapsed">
                            <div class="subwindow-container collapsed">
                              <div class="subwindow-container-fix client-details-contents">
                                <section class="client-details">
                                  <div class="client-picture">
                                    <img :src="customerData.imageUrl == '' ? '/static/img/placeholder.png' : '/image/Guest/' + customerData.imageUrl + '?' + Date.now()">
                                  </div>
                                  <div class="client-name">{{ customerData.name }}</div>
                                  <!-- <div class="edit-buttons">
                                    <div class="button edit"><i class="icon ion-pencil-square"></i></div>
                                  </div> -->
                                  <div class="client-details-box clearfix">
                                    <div class="client-details-left">
                                      <div class="client-detail">
                                        <span class="label">Email</span>                                                                          
                                        <span class="detail client-email">{{ customerData.emailAddress }}</span>                                                                          
                                      </div>
                                    </div>
                                    <div class="client-details-right">
                                      <div class="client-detail">
                                        <span class="label">Member No.</span>                                                                          
                                        <span class="detail client-id">{{ customerData.memberNo }}</span>                                                                                                                                                    
                                      </div>
                                    </div>
                                  </div>
                                </section>                                                              
                              </div>
                            </div>
                          </section>
                          <section class="subwindow">
                            <div class="subwindow-container">
                              <div class="subwindow-container-fix touch-scrollable scrollable-y">
                                <table class="client-list">
                                  <thead>
                                    <tr>
                                      <th>Name</th>
                                      <th>Email Address</th>
                                      <th>Member No.</th>
                                    </tr>
                                  </thead>
                                  <tbody class="client-list-contents">
                                    <tr class="client-line" v-for="(row, i) in listCustomer" v-bind:key="i" @click="onChooseCustomer(row, i)" :class="{highlight:customerIndex == i}">
                                      <td>{{ row.firstName + ' ' + row.lastName }}</td>
                                      <td>{{ row.emailAddress }}</td>
                                      <td>{{ row.memberNo }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </section>
                        </div>
                      </section>
                    </div>
                  </div>                                    
                  <div class="payment-screen screen" v-if="viewType == VIEW_PAYMENT">
                    <div class="screen-content">
                      <div class="top-content">
                        <span class="button back" @click="onBackPayment()">
                          <i class="icon ion-angle-double-left"></i>
                          Back
                        </span>
                        <h1>Payment</h1>
                        <span class="button next highlight" @click="onPreValidatePayment()">
                          Validate
                          <i class="icon ion-angle-double-right"></i>
                        </span>
                      </div>
                      <div class="left-content pc40 touch-scrollable scrollable-y">
                        <div class="paymentmethods-container">
                          <div class="paymentmethods">                  
                            <div v-for="(row, i) in listPaymentMethod" v-bind:key="i" class="button paymentmethod" @click="onSelectPaymentMethod(row)">
                                {{ row.paymentMethodName }}
                            </div>                                             
                          </div>
                        </div>
                      </div>
                      <div class="right-content pc60 touch-scrollable scrollable-y">
                        <section class="paymentlines-container" v-if="emptyPaymentMethod">
                          <div class="paymentlines-empty">
                            <div class="total">
                                {{ totalAmount }}
                            </div>
                            <div class="message">
                                Please select a payment method. 
                            </div>
                          </div>
                        </section>

                        <section class="paymentlines-container" v-if="!emptyPaymentMethod">
                          <table class="paymentlines">
                            <colgroup>
                              <col class="due">
                              <col class="tendered">
                              <col class="change">
                              <col class="method">
                              <col class="cardno">
                              <col class="controls">
                            </colgroup>
                            <thead>
                              <tr class="label">
                                <th>Due</th>
                                <th>Tendered</th>
                                <th>Change</th>
                                <th>Method</th>
                                <th>Card No.</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>                                            
                              <tr class="paymentline" v-for="(row, i) in listPaymentLine" v-bind:key="i" @click="onSelectPaymentLine(row, i)" :class="{selected:paymentLineIndex == i}">
                                <td class="col-due"> {{ row.due }} </td>
                                <td class="col-tendered" :class="{edit:paymentLineIndex == i}">{{ row.tendered }}</td>                                                                
                                <td class="col-change" :class="{highlight:row.change != '' && paymentLineIndex == i}">{{ row.change }}</td>                                                                    
                                <td class="col-name"> {{ row.method }} </td>
                                <td class="col-cardno">{{ row.cardno }}</td>  
                                <td class="delete-button" @click="onDeletePaymentLine(i)"><i class="icon ion-times-circle"></i></td>
                              </tr>                                                                                        
                            </tbody>    
                          </table>
                        </section>

                        <section class="payment-numpad">
                          <div class="numpad">
                            <button class="input-button number-char" @click="onClickPaymentNumpad('1')">1</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('2')">2</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('3')">3</button>
                            <button class="mode-button" @click="onClickPaymentNumpad('TENDERED')" id="TENDERED">Tendered</button>
                            <br>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('4')">4</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('5')">5</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('6')">6</button>
                            <button class="mode-button" @click="onClickPaymentNumpad('CARDNO')" id="CARDNO">Card No</button>
                            <br>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('7')">7</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('8')">8</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('9')">9</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('.000')">.000</button>
                            <br>
                            <button class="input-button numpad-char" @click="onClickPaymentNumpad('CLEAR')">C</button>
                            <button class="input-button number-char" @click="onClickPaymentNumpad('0')">0</button>
                            <button class="input-button number-char"></button>
                            <button class="input-button numpad-backspace" @click="onClickPaymentNumpad('BACKSPACE')">
                                <img height="21" src="/static/img/backspace.png" width="24">
                            </button>
                           </div>
                        </section>

                          <div class="payment-buttons">
                            <div class="button js_set_customer" @click="onDisplayScreenCustomer(viewType)">
                              <i class="icon ion-user"></i> 
                              <span class="js_customer_name">{{ customerSelectedName }}</span>
                            </div>                                                                                                                        
                          </div>
                      </div>
                    </div>
                  </div>
                  <div class="clientlist-screen screen"  v-if="viewType == VIEW_ORDER">
                    <div class="screen-content">
                      <section class="top-content">
                          <span class="button back" @click="onBackCustomer()">
                              <i class="icon ion-angle-double-left"></i>
                              Cancel
                          </span>
                          <span class="searchbox">
                              <input type="text" v-on:keyup.enter="onSearchOrder($event)" placeholder="Search Doc. Number">
                              <span class="search-clear"></span>
                          </span>
                          <!-- <span class="searchbox"></span>
                          <span class="button new-customer">
                              <i class="icon ion-user"></i>
                              <i class="icon ion-plus"></i>
                          </span> -->
                          <span class="button next highlight" @click="onRePrint()">{{ textButtonSetOrder }}</span>
                      </section>
                      <section class="full-content">
                        <div class="window">
                          <section class="subwindow collapsed">
                            <div class="subwindow-container collapsed">
                              <div class="subwindow-container-fix client-details-contents">
                                <section class="client-details">
                                  <div class="client-name">{{ orderData.name }}</div>
                                  <!-- <div class="edit-buttons">
                                    <div class="button edit"><i class="icon ion-pencil-square"></i></div>
                                  </div> -->
                                  <div class="client-details-box clearfix">
                                    <div class="client-details-left">
                                      <div class="client-detail">
                                        <span class="label">Document Date</span>                                                                          
                                        <span class="detail client-email">{{ orderData.documentDate }}</span>                                                                          
                                      </div>
                                    </div>
                                    <div class="client-details-right">
                                      <div class="client-detail">
                                        <span class="label">Amount</span>                                                                          
                                        <span class="detail client-id">{{ orderData.amount }}</span>                                                                                                                                                    
                                      </div>
                                    </div>
                                    <div class="client-details-right">
                                      <div class="client-detail">
                                        <span class="label">Status</span>                                                                          
                                        <span class="detail client-id">{{ orderData.status }}</span>                                                                                                                                                    
                                      </div>
                                    </div>
                                  </div>
                                </section>                                                              
                              </div>
                            </div>
                          </section>
                          <section class="subwindow">
                            <div class="subwindow-container">
                              <div class="subwindow-container-fix touch-scrollable scrollable-y">
                                <table class="client-list">
                                  <thead>
                                    <tr>
                                      <th>Doc. Number</th>
                                      <th>Date</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody class="client-list-contents">
                                    <tr class="client-line" v-for="(row, i) in listOrder" v-bind:key="i" @click="onChooseOrder(row, i)" :class="{highlight:orderIndex == i}">
                                      <td>{{ row.name }}</td>
                                      <td>{{ row.documentDate }}</td>
                                      <td>{{ row.totalAmountIncludeTax }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </section>
                        </div>
                      </section>
                    </div>
                  </div>
                  <div class="receipt-screen screen" v-if="viewType == VIEW_RECEIPT">
                    <div class="screen-content">
                      <div class="top-content">
                        <h1>Change: <span class="change-value">{{ changeAmount }}</span></h1>
                        <span class="button next highlight" @click="onNextOrder()">
                          Next Order
                          <i class="icon ion-angle-double-right"></i>
                        </span>
                      </div>
                      <div class="centered-content touch-scrollable">
                        <div class="button print" @click="onPrintReceiptMember(listOrder)">
                          <i class="icon ion-printer"></i> Print Membership
                        </div>                        
                        <div class="button print" @click="onPrintReceipt()">
                          <i class="icon ion-printer"></i> Print Receipt
                        </div>
                        <div class="pos-receipt-container" id="printableArea">
                          <div class="pos-sale-ticket">    
                          <!-- <div class="pos-sale-ticket" id="printableArea">    -->
                            <img :src="'/image/Project/' + projectImageUrl" height="60px">      
                            <div class="pos-center-align">{{ orderDate }}</div>
                            <div class="pos-center-align">{{ orderNo }}</div>
                            <br>
                            Project: {{ projectName }}<br>
                            <!-- <div class="receipt-phone">
                              Phone: <br>
                            </div> -->
                            <div class="receipt-user">
                              Cashier: {{ cashierName }}<br>
                            </div>
                            <br>
                            <div class="receipt-membership">
                              Customer: {{ customerSelectedName }}<br>
                            </div>
                            <br>
                            <table class="receipt-orderlines">
                              <colgroup>
                                <col width="50%">
                                <col width="25%">
                                <col width="25%">
                              </colgroup>
                              <tbody>
                                <tr v-for="(row, i) in itemReceipt" v-bind:key="i">
                                  <td>{{ row.name }}</td>
                                  <td class="pos-right-align">{{ row.quantity }} {{ row.uom }}</td>
                                  <td class="pos-right-align">{{ row.amount }}</td>
                                </tr>
                                <!-- <tr v-if="row.discount != ''">
                                  <td></td>
                                  <td class="pos-right-align">Discount</td>
                                  <td class="pos-right-align">{{ row.discount }}</td>
                                </tr>
                                <tr v-if="row.tax != ''">
                                  <td></td>
                                  <td class="pos-right-align">Tax</td>
                                  <td class="pos-right-align">{{ row.tax }}</td>
                                </tr>                                                              -->
                              </tbody>
                            </table>
                            <br>
                            <table class="receipt-total">
                              <tbody>
                                <tr>
                                  <td>Subtotal:</td>
                                  <td class="pos-right-align">{{ subTotalAmount }}</td>
                                </tr>                                
                                <tr>
                                  <td>Tax:</td>
                                  <td class="pos-right-align">{{ taxAmount }}</td>                                                                    
                                </tr>
                                <tr class="emph">
                                  <td>Total:</td>
                                  <td class="pos-right-align">{{ totalAmount }}</td>
                                </tr>
                              </tbody>
                            </table>
                            <br>
                            <table class="receipt-paymentlines">                                
                              <tbody>
                                <tr v-for="(row, i) in listPaymentLine" v-bind:key="i">
                                  <td>
                                    {{ row.method }}
                                  </td>
                                  <td class="pos-right-align">
                                    {{ row.tendered }}
                                  </td>
                                </tr>                                                              
                              </tbody>
                            </table>
                            <br>
                            <table class="receipt-change">
                              <tbody>
                                <tr>
                                  <td>Change:</td>
                                  <td class="pos-right-align">
                                  {{ changeAmount }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <table class="receipt-paymentlines">
                              <tbody>
                                <tr>
                                  <td>RRN:</td>
                                  <td class="pos-right-align">
                                  {{ rrnNumber }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                            <table class="receipt-orderlines">
                              <colgroup>
                                <col width="100%">
                              </colgroup>
                              <tbody>
                                <tr v-for="(row, i) in passCodes" v-bind:key="i" style="display:block; padding-top:20px">
                                  <td>
                                    <div :id="`passCode-${row.id}`"></div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
          </div>
        </div>                
      </div>
    </div>

    <div id="modal-view-file" class="modal fade modal-dialog modal-lg " style="display:none" >
      <div class="modal-content">
        <div class="modal-body">
          <iframe id="viewer" style="width:95%;height:360px;border:1px;"></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
          <button type="button" class="btn btn-primary" @click="onPrintPdf()">Print</button>
        </div>
      </div>
    </div>

    <div id="modal-qris" class="modal-dialog-qris" style="display:none">
      <div class="popup">
        <h2 style="margin-bottom:0px;">Please scan QRIS</h2>
        <h5 style="margin-top:0px;">{{ elapsedTime }}</h5>
        <div id="qrcode" class="qris">
        </div>
        <div id="message"></div>
        <div style="padding:10px; text-align:center;">
          <button type="button" class="btn btn-danger" @click="onCancelQRIS()" style="color:white;">Cancel</button>
          <button type="button" class="btn btn-primary" @click="onResumeGetStatus()" style="color:white;">Resume</button>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../../api'
import SweetAlert from 'sweetalert2'
import utilities from '../../../utilities'
import config from '../../../config'
import axios from 'axios'

const EMPTY_CART = true
const SESSION_LOCAL_STORAGE_NAME = 'session_storage'
const VIEW_INITIAL = 'initial'
const VIEW_CUSTOMER = 'customer'
const VIEW_ORDER = 'order'
const VIEW_CUSTOMER_DETAIL = 'customer_detail'
const VIEW_PAYMENT = 'payment'
const VIEW_RECEIPT = 'receipt'
const PAYMENT_METHOD_ID = 'fd777841-e4f8-443e-9739-921e4f74a415'
const PAYMENT_METHOD_NAME = 'POSAdmin'

export default {
  name: 'PointOfSales',
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      VIEW_INITIAL: VIEW_INITIAL,
      VIEW_CUSTOMER: VIEW_CUSTOMER,
      VIEW_ORDER: VIEW_ORDER,
      VIEW_CUSTOMER_DETAIL: VIEW_CUSTOMER_DETAIL,
      VIEW_PAYMENT: VIEW_PAYMENT,
      VIEW_RECEIPT: VIEW_RECEIPT,
      EMPTY_CART: EMPTY_CART,
      SESSION_LOCAL_STORAGE_NAME: SESSION_LOCAL_STORAGE_NAME,
      PAYMENT_METHOD_ID: PAYMENT_METHOD_ID,
      PAYMENT_METHOD_NAME: PAYMENT_METHOD_NAME,
      emptyCartStatus: true,
      listProductCategory: null,
      listProduct: null,
      listBreadCrumb: null,
      listPOSSession: null,
      posSession: null,
      posSessionId: 0,
      posSessionName: '',
      loginSeqNo: 0,
      listSession: null,
      session: null,
      sessionNo: 0,
      sessionTime: '',
      listCart: null,
      subTotalAmount: '',
      taxAmount: '',
      totalAmount: '',
      lastSessionNo: 0,
      cartItemIndex: undefined,
      viewType: null,
      viewTypeReceipt: null,
      listCustomer: null,
      listPaymentMethod: null,
      customerData: {
        name: '',
        emailAddress: '',
        memberNo: '',
        imageUrl: ''
      },
      orderData: {
        name: '',
        documentDate: '',
        amount: '',
        returnAmount: '',
        paidAmount: '',
        status: ''
      },
      inquiryParam: {
        WhereClauseProduct: '',
        WhereClauseMember: '',
        WhereClauseOrder: '',
        CurrentPageNumber: 1,
        PageSize: 99999,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      customerIndex: undefined,
      customerSetIndex: undefined,
      customerSelectedId: undefined,
      customerSelectedName: '',
      totalPayment: 0,
      previousView: VIEW_INITIAL,
      textButtonSetCustomer: '',
      textButtonSetOrder: '',
      emptyPaymentMethod: true,
      listPaymentLine: null,
      paymentLineIndex: undefined,
      remainDuePayment: 0,
      listGuestMembership: null,
      listProductFromMembership: null,
      listGetProductCategory: null,
      // START-for print receipt
      listOrder: null,
      listOrderItems: null,
      changeAmount: '',
      orderDate: '',
      orderNo: '',
      orderIndex: undefined,
      orderSetIndex: undefined,
      orderSelectedId: undefined,
      corderSelectedName: '',
      projectId: 0,
      projectName: '',
      projectImageUrl: '',
      cashierId: 0,
      cashierName: '',
      subTotal: '',
      tax: '',
      total: '',
      itemReceipt: null,
      // END-for print receipt
      buttonMode: '',
      qrisID: '',
      interval: 0,
      rrnNumber: '',
      passCodes: null,
      listProductAll: null,
      elapsedTime: '',
      startTime: null
    }
  },
  computed: {
  },
  async created() {
    if (config.isDualScreen) {
      this.screenDetails = await window.getScreenDetails()
    }
    // let qrScript = document.createElement('script')
    // qrScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js')
    // document.head.appendChild(qrScript)

    let me = this
    this.posSessionId = this.$route.params.sessionId
    this.posSessionName = this.$route.params.sessionName
    this.cashierId = this.$route.params.cashierId
    this.cashierName = this.$route.params.cashierName
    this.projectId = this.$route.params.projectId
    this.projectName = this.$route.params.projectName
    this.projectImageUrl = this.$route.params.projectImageUrl
    this.pointOfSalesId = this.$route.params.pointOfSalesId
    // this.loginSeqNo = this.$route.params.loginSeqNo

    this.getPaymentMethod(this.pointOfSalesId)
    this.customerSelectedName = this.customerSelectedName === '' ? 'Customer' : this.customerSelectedName

    // Get session info from local storage
    this.getLocalStorage()

    this.loginSeqNo = this.loginSeqNo ? this.loginSeqNo + 1 : 1

    if (this.listPOSSession) {
      let isFound = false
      this.listPOSSession.forEach(row => {
        if (row.posSessionId === me.posSessionId) {
          me.posSession = row
          me.loginSeqNo = me.posSession.loginSeqNo
          me.posSessionId = me.posSession.posSessionId
          me.posSessionName = me.posSession.posSessionName

          me.listSession = me.posSession.session
          // Add null check for listSession
          if (!me.listSession || me.listSession.length === 0) {
            this.addSession(1)
          } else {
            me.listCart = me.listSession[0].cartItem
            me.sessionNo = me.listSession[0].no
            me.sessionTime = me.listSession[0].time
            me.lastSessionNo = me.sessionNo // me.getLastSessionNo(me.listSession)
          }

          isFound = true
          return
        }
      })
      if (!isFound) {
        this.addPOSSession()
        this.addSession(1)
        this.updateLocalStorage()
      }
    } else {
      this.addPOSSession()
      this.addSession(1)
      this.updateLocalStorage()
    }
    // if (!this.listPOSSession) {
    //   this.initSession()
    // }

    if (this.listCart) {
      if (this.listCart.length > 0) {
        this.emptyCartStatus = false
      } else {
        this.emptyCartStatus = true
      }
      this.calculateTotalAmount()
    } else {
      this.emptyCartStatus = true
    }

    var styleSheets = document.styleSheets
    var href = '/static/css/bootstrap.min.css'
    for (var i = 0; i < styleSheets.length; i++) {
      if (styleSheets[i].href.match(href)) {
        styleSheets[i].disabled = true
        break
      }
    }

    this.viewType = VIEW_INITIAL
  },
  mounted() {
    $('body').removeAttr('style')
    $('body').css('overflowY', 'hidden')
  },
  methods: {
    getProductCategory() {
      console.log(inquiryByProductCategory)

      var inquiryByProductCategory = this.listGetProductCategory.map(item => `'${item.productCategoryId}'`).join(',')
      api
        .request('Guest', 'get', '/api/ProductCategory/Inquiry?WhereClause=id IN (' + inquiryByProductCategory + ')' +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listProductCategory = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProduct(productCategoryId) {
      var day = new Date().getDay()
      var isWeekend = (day === 6) || (day === 0) // 6 = Saturday, 0 = Sunday

      let url = ''
      url = productCategoryId ? '/api/Product/InquiryByProjectByProductCategory?ProductCategoryId=' + productCategoryId + '&ProjectId=' + this.projectId : '/api/Product/Inquiry/Project/' + this.projectId

      api
        .request('Sales', 'get', url, null)
        .then(response => {
          var listProductTemp = response.data.entity
          if (listProductTemp) {
            listProductTemp.forEach(element => {
              element.price = isWeekend ? element.priceWeekEnd : element.priceWeekDay
            })
          }
          this.listProduct = listProductTemp
          this.listProductAll = listProductTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPaymentMethod(pointOfSalesId) {
      if (pointOfSalesId) {
        api
          .request('POS', 'get', '/api/POS/GetDetail?Id=' + pointOfSalesId, null)
          .then(response => {
            var data = response.data
            this.listPaymentMethod = data.entity.paymentMethod
            this.listGetProductCategory = data.entity.productCategory
            console.log(this.listGetProductCategory)
            this.getProductCategory()
            this.getProduct()
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      } else {
        SweetAlert.fire('Error', 'ID of POS is empty', 'error')
      }
    },
    onClickProductCategory(data) {
      this.getProduct(data.id)
      this.listBreadCrumb = []
      this.listBreadCrumb.push({
        id: data.id,
        name: data.name
      })
      this.listProductCategory = null
    },
    onClickHomeBreadCrumb() {
      this.getProductCategory()
      this.inquiryParam.WhereClauseProduct = ''
      this.getProduct()
      this.listBreadCrumb = []
    },
    // initSession() {
    //   let currentTime = new Date()
    //   this.sessionNo = 1
    //   this.lastSessionNo = 1
    //   this.sessionTime = currentTime.getHours().toString().padStart(2, '0') + ':' + currentTime.getMinutes().toString().padStart(2, '0')
    //   this.listCart = []
    //   this.session = {
    //     no: this.sessionNo,
    //     time: this.sessionTime,
    //     cartItem: this.listCart
    //   }
    //   this.listSession = []
    //   this.listSession.push(this.session)

    //   this.posSession = {
    //     posSessionId: this.posSessionId,
    //     posSessionName: this.posSessionName,
    //     loginSeqNo: this.loginSeqNo,
    //     session: this.listSession
    //   }

    //   if (!this.listPOSSession) {
    //     this.listPOSSession = []
    //     this.listPOSSession.push(this.posSession)
    //   }

    //   if (this.listCart.length > 0) {
    //     this.emptyCartStatus = false
    //   } else {
    //     this.emptyCartStatus = true
    //   }
    // },
    addSession(sessionNo) {
      let currentTime = new Date()
      this.sessionNo = sessionNo
      this.lastSessionNo = sessionNo
      this.sessionTime = currentTime.getHours().toString().padStart(2, '0') + ':' + currentTime.getMinutes().toString().padStart(2, '0')
      this.listCart = []
      this.session = {
        no: this.sessionNo,
        time: this.sessionTime,
        cartItem: this.listCart
      }
      // Initialize listSession if it's null or undefined
      if (!this.listSession) {
        this.listSession = []
      }
      this.listSession.push(this.session)

      if (this.listCart.length > 0) {
        this.emptyCartStatus = false
      } else {
        this.emptyCartStatus = true
      }
    },
    addPOSSession() {
      this.listSession = []
      this.posSession = {
        posSessionId: this.posSessionId,
        posSessionName: this.posSessionName,
        loginSeqNo: this.loginSeqNo,
        session: this.listSession
      }
      if (!this.listPOSSession) {
        this.listPOSSession = []
      }
      this.listPOSSession.push(this.posSession)
    },
    getLastSessionNo(listSession) {
      let lastSession = 0
      listSession.forEach(item => {
        lastSession = item.sessionNo > lastSession ? item.sessionNo : lastSession
      })
      return lastSession
    },
    getLocalStorage() {
      this.listPOSSession = JSON.parse(window.localStorage.getItem(this.SESSION_LOCAL_STORAGE_NAME))

      // let me = this
      // if (this.listPOSSession) {
      //   this.listPOSSession.forEach(row => {
      //     if (row.posSessionId === me.posSessionId) {
      //       me.posSession = row
      //       return
      //     }
      //   })
      //   if (this.posSession) {
      //     this.listSession = this.posSession.session
      //     if (this.listSession) {
      //       this.session = this.listSession[0]
      //       this.sessionNo = this.session.no
      //       this.sessionTime = this.session.time
      //       this.listCart = this.session.cartItem
      //       this.lastSessionNo = this.getLastSessionNo(this.listSession)
      //     }
      //   }
      // }
    },
    updateLocalStorage() {
      window.localStorage.setItem(SESSION_LOCAL_STORAGE_NAME, JSON.stringify(this.listPOSSession))
      if (config.isDualScreen) {
        this.refreshPOSCustomer()
      }
    },
    refreshPOSCustomer() {
      window.open('/pos-customer?sessionId=' + this.posSessionId + '&qrData=', 'POSCustomer')
    },
    onSearchProduct(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      this.inquiryParam.WhereClauseProduct = whereClause.join(' ')
      this.getProduct()
    },
    // selectProductFromMembership(data, dataGuestMembership) {
    //   let i = 0
    //   data.forEach(item => {
    //     // if (qty.id === data.id) {
    //     // }
    //     // console.log(dataGuestMembership[i].membershipId + ' ' + item.membershipId)
    //     if (dataGuestMembership[i].membershipId === item.membershipId) {
    //       this.$set(item, 'quantity', dataGuestMembership[i].quotaGroup)
    //     }

    //     this.onSelectProduct(item)
    //     i++
    //   })
    // },
    onSelectProduct(data) {
      if (data.priceWeekDay === '0') {
        SweetAlert.fire('Warning', 'The price is zero !', 'warning')
      } else {
        if (!this.listCart) {
          this.listCart = []
        }
        this.listCart.push({
          id: data.id,
          name: data.name,
          price: utilities.ParseNumber(data.currentPrice),
          qty: data.quantity === undefined ? 1 : data.quantity,
          uom: data.uoM,
          tax: utilities.ParseNumber(data.tax),
          discount: utilities.ParseNumber(data.discount),
          discountPercentage: utilities.ParseNumber(data.discountPercentage),
          currencyId: data.currencyId,
          membershipId: data.membershipId
        })
        this.emptyCartStatus = false
        this.updateLocalStorage()
        this.calculateTotalAmount()
      }
    },
    calculateTotalAmount() {
      var subTotalAmount = 0
      var taxAmount = 0
      var totalAmount = 0
      // Add null check for listCart
      if (this.listCart && Array.isArray(this.listCart)) {
        this.listCart.forEach(function(item) {
          item.amount = Math.round(item.price * item.qty, 0)
          item.taxAmount = Math.round(item.tax / 100 * (item.amount - item.discount), 0)
          subTotalAmount = subTotalAmount + item.amount - item.discount
          taxAmount = taxAmount + item.taxAmount
        })
      }
      totalAmount = subTotalAmount + taxAmount

      this.subTotalAmount = this.displayNumber(subTotalAmount)
      this.taxAmount = this.displayNumber(taxAmount)
      this.totalAmount = this.displayNumber(totalAmount)
    },
    displayNumber(input) {
      return utilities.DisplayNumber(input)
    },
    onClickNumpad(input) {
      var newbuf = ''
      // Remove Qty from right to left
      if (input === 'BACKSPACE') {
        newbuf = String(this.listCart[this.cartItemIndex].qty)
        if (newbuf !== '0') {
          newbuf = newbuf.substring(0, newbuf.length - 1)
          this.listCart[this.cartItemIndex].qty = newbuf
        }

        if (newbuf === '') {
          this.listCart[this.cartItemIndex].qty = 0
        }
        if (newbuf === '0') {
          this.listCart.splice(this.cartItemIndex, 1)
        }
      // Change Qty
      } else if (!isNaN(parseInt(input))) {
        newbuf = String(this.listCart[this.cartItemIndex].qty)
        if (newbuf === '0') {
          newbuf = '' + input
        } else {
          newbuf += input
        }
        this.listCart[this.cartItemIndex].qty = parseFloat(newbuf)
      }

      if (this.listCart.length <= 0) {
        this.emptyCartStatus = true
      }
      this.updateLocalStorage()
      // this.getTotalAmount
      this.calculateTotalAmount()
    },
    onDisplayScreenCustomer(previousView) {
      this.previousView = previousView
      this.textButtonSetCustomer = this.customerSelectedId ? 'Deselect Customer' : 'Set Customer'

      if (this.customerSetIndex) {
        this.customerIndex = this.customerSetIndex
        this.customerData.name = this.listCustomer[this.customerSetIndex].firstName + ' ' + this.listCustomer[this.customerSetIndex].lastName
        this.customerData.emailAddress = this.listCustomer[this.customerSetIndex].emailAddress
        this.customerData.memberNo = this.listCustomer[this.customerSetIndex].memberNo
        this.customerData.imageUrl = this.listCustomer[this.customerSetIndex].imageUrl
      }
      this.inquiryParam.SortExpression = 'ChangedDate'
      this.inquiryParam.PageSize = '15'
      this.inquiryParam.SortDirection = 'DESC'
      api
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseMember +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listCustomer = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewType = VIEW_CUSTOMER
    },
    onSearchMember(evt) {
      var keyWords = evt.target.value
      var whereClause = [
        'FirstName', 'like', "'%" + keyWords + "%'", 'or',
        'LastName', 'like', "'%" + keyWords + "%'", 'or',
        'EmailAddress', 'like', "'%" + keyWords + "%'"
      ]
      this.inquiryParam.WhereClauseMember = whereClause.join(' ')
      this.onDisplayScreenCustomer(this.previousView)
    },
    onBackCustomer() {
      this.viewType = this.previousView
    },
    onChooseCustomer(data, idx) {
      this.customerData.name = data.firstName + ' ' + data.lastName
      this.customerData.emailAddress = data.emailAddress
      this.customerData.memberNo = data.memberNo
      this.customerData.imageUrl = data.imageUrl
      this.customerIndex = idx

      this.textButtonSetCustomer = 'Set Customer'
    },
    onSetCustomer() {
      if (this.textButtonSetCustomer === 'Set Customer') {
        this.customerSetIndex = this.customerIndex
        this.customerSelectedId = this.listCustomer[this.customerSetIndex].id
        this.customerSelectedName = this.listCustomer[this.customerSetIndex].firstName + ' ' + this.listCustomer[this.customerSetIndex].lastName

        // // Get guest membership with status => submit
        // let arrMembershipId = []
        // api
        //   .request('Guest', 'get', '/api/Guest/GetMembershipSubmit?GuestId=' + this.customerSelectedId, null)
        //   .then(response => {
        //     var data = response.data
        //     this.listGuestMembership = data.entity

        //     // Populate membership id
        //     this.listGuestMembership.forEach(itemGuestMembership => {
        //       arrMembershipId.push(itemGuestMembership.membershipId)
        //       var arrMembershipIdUnique = arrMembershipId.filter(function(item, index) {
        //         return arrMembershipId.indexOf(item) >= index
        //       })
        //       arrMembershipId = arrMembershipIdUnique
        //     })
        //   })
        //   .then(response => {
        //     var reqData = {
        //       Id: arrMembershipId
        //     }
        //     api
        //       .request('Sales', 'post', '/api/Product/InquiryByMembershipId', reqData)
        //       .then(response => {
        //         var data = response.data
        //         this.listProductFromMembership = data.entity
        //         this.selectProductFromMembership(this.listProductFromMembership, this.listGuestMembership)
        //       })
        //       .catch(error => {
        //         var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
        //         SweetAlert.fire('Error', message, 'error')
        //       })
        //   })
        //   .catch(error => {
        //     var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
        //     SweetAlert.fire('Error', message, 'error')
        //   })
      } else {
        this.customerSetIndex = undefined
        this.customerSelectedId = undefined
        this.customerSelectedName = 'Customer'
        this.customerData.name = ''
        this.customerData.emailAddress = ''
        this.customerData.memberNo = ''
        this.customerData.imageUrl = ''
        this.customerIndex = undefined
      }

      this.viewType = this.previousView
    },
    onPayment() {
      this.remainDuePayment = utilities.ParseNumber(this.totalAmount)
      this.listPaymentLine = []
      this.viewType = VIEW_PAYMENT
    },
    onBackPayment() {
      this.viewType = VIEW_INITIAL

      // QRIS Blank
      this.updatePOSCustomer('')
    },
    onNextOrder() {
      this.lastSessionNo = this.lastSessionNo + 1
      this.addSession(this.lastSessionNo)
      this.updateLocalStorage()
      this.viewType = VIEW_INITIAL
    },
    onClose() {
      this.updateLocalStorage(false)

      var styleSheets = document.styleSheets
      var href = '/static/css/bootstrap.min.css'
      for (var i = 0; i < styleSheets.length; i++) {
        if (styleSheets[i].href.match(href)) {
          styleSheets[i].disabled = false
          break
        }
      }

      window.history.back()
    },
    onGetQRISStatus() {
      var thiss = this

      let currentTime = Date.now()
      let elapsedTime = Math.floor((currentTime - thiss.startTime) / 1000) // Elapsed time in seconds

      let hours = Math.floor(elapsedTime / 3600)
      let minutes = Math.floor((elapsedTime % 3600) / 60)
      let seconds = elapsedTime % 60

      // Format as HH:MM:SS
      thiss.elapsedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

      api
        .request('Payment', 'get', '/api/Payment/QRIS?id=' + thiss.qrisID, null)
        .then(response => {
          if (response.data.entity.transactionInfo.responseCode === '00') {
            clearInterval(thiss.interval)

            thiss.elapsedTime = 'Timer stopped'

            let paidAmount = 0
            let returnAmount = 0
            thiss.listPaymentLine.forEach(item => {
              paidAmount = paidAmount + utilities.ParseNumber(item.tendered)
              returnAmount = returnAmount + utilities.ParseNumber(item.change)
            })

            window.$('#modal-qris').modal('hide')
            thiss.updatePOSCustomer('')

            thiss.onValidatePayment(paidAmount, returnAmount, response.data.entity.transactionInfo.id)
          }

          if (response.data.entity.transactionInfo.responseCode !== null &&
              response.data.entity.transactionInfo.responseCode !== '' &&
              response.data.entity.transactionInfo.responseCode !== '00') {
            clearInterval(thiss.interval)
            thiss.elapsedTime = response.data.entity.transactionInfo.transactionStatus + ' with reason: ' + response.data.entity.transactionInfo.responseReason + '(' + response.data.entity.transactionInfo.responseCode + ')'

            thiss.updatePOSCustomer('')
          }
        })
        .catch(error => {
          console.log(error)
          // var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          // SweetAlert.fire('Error', error, 'error')
        })
    },
    onCancelQRIS() {
      clearInterval(this.interval)
      window.$('#modal-qris').modal('hide')
      this.updatePOSCustomer('')

      this.listPaymentLine = []
    },
    onResumeGetStatus() {
      clearInterval(this.interval)
      this.elapsedTime = ''

      this.interval = setInterval(this.onGetQRISStatus, 3000)
    },
    async updatePOSCustomer(qrData) {
      if (!config.isDualScreen) {
        return
      }

      let screenDetails = await window.getScreenDetails()
      let customerScreen

      if (window.screen.isExtended && screenDetails.screens.length > 1) {
        customerScreen = screenDetails.screens[1]
      } else {
        customerScreen = screenDetails.screens[0]
      }

      let windowWidth = customerScreen.availWidth // customerScreen.width / 2
      let windowHeight = customerScreen.availHeight // customerScreen.height / 2
      let leftExtendedScreen = customerScreen.left
      let topExtendedScreen = customerScreen.top
      let xPosition = leftExtendedScreen // + (customerScreen.width / 2) - (windowWidth / 2)
      let yPosition = topExtendedScreen // + (customerScreen.height / 2) - (windowHeight / 2)

      const qrisWindow = window.open('/pos-customer?sessionId=' + this.posSessionId + '&qrData=' + qrData, 'POSCustomer', 'toolbar=no,scrollbars=no,resizable=no,width=' + windowWidth + ',height=' + windowHeight)
      qrisWindow.moveTo(xPosition, yPosition)
    },
    onSelectPaymentMethod(paymentMethod) {
      var thiss = this

      if (paymentMethod.paymentMethodName === 'QRIS') {
        let param = {
          projectId: thiss.projectId,
          amount: thiss.remainDuePayment.toString()
        }

        api
          .request('Payment', 'post', '/api/Payment/QRIS', param)
          .then(response => {
            if (response.data.returnStatus === true) {
              if (response.data.entity.qrString !== '' && response.data.entity.qrString !== undefined) {
                document.getElementById('qrcode').innerHTML = ''
                var qr = new window.QRCode(document.getElementById('qrcode'), {
                  width: 350,
                  height: 350
                })
                qr.makeCode(response.data.entity.qrString)
              }
              window.$('#modal-qris').modal({
                backdrop: 'static',
                keyboard: false
              })

              thiss.elapsedTime = 'Starting'
              thiss.startTime = Date.now()

              thiss.updatePOSCustomer(response.data.entity.qrString)
              thiss.qrisID = response.data.entity.id
              thiss.interval = setInterval(this.onGetQRISStatus, 3000)

              let initialTenderedAmount = thiss.remainDuePayment

              thiss.listPaymentLine.push({
                due: utilities.DisplayNumber(thiss.remainDuePayment),
                tendered: utilities.DisplayNumber(initialTenderedAmount),
                change: '',
                method: paymentMethod.paymentMethodName,
                cardno: '',
                currencyId: paymentMethod.currencyId,
                paymentMethodId: paymentMethod.paymentMethodId,
                qrisId: thiss.qrisID
              })
              thiss.paymentLineIndex = thiss.listPaymentLine.length - 1
              thiss.emptyPaymentMethod = false

              thiss.buttonMode = 'TENDERED'
              let elBtnMode = document.getElementById('TENDERED')
              elBtnMode.classList.add('selected-mode')

              elBtnMode = document.getElementById('CARDNO')
              elBtnMode.classList.remove('selected-mode')
            } else {
              SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
              thiss.listPaymentLine = []
            }
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      } else {
        // QRIS Blank
        this.updatePOSCustomer('')

        let initialTenderedAmount = 0

        this.listPaymentLine.push({
          due: utilities.DisplayNumber(thiss.remainDuePayment),
          tendered: utilities.DisplayNumber(initialTenderedAmount),
          change: '',
          method: paymentMethod.paymentMethodName,
          cardno: '',
          currencyId: paymentMethod.currencyId,
          paymentMethodId: paymentMethod.paymentMethodId,
          qrisId: ''
        })
        this.paymentLineIndex = this.listPaymentLine.length - 1
        this.emptyPaymentMethod = false

        this.buttonMode = 'TENDERED'
        let elBtnMode = document.getElementById('TENDERED')
        elBtnMode.classList.add('selected-mode')

        elBtnMode = document.getElementById('CARDNO')
        elBtnMode.classList.remove('selected-mode')
      }
    },
    onSelectPaymentLine(data, idx) {
      this.paymentLineIndex = idx
    },
    onDeletePaymentLine(idx) {
      this.listPaymentLine.splice(idx, 1)
      if (this.listPaymentLine.length <= 0) {
        this.emptyPaymentMethod = true
      }

      // Recalculate next payment line
      let prevIndex = 0
      if (idx - 1 < 0) {
        this.remainDuePayment = utilities.ParseNumber(this.totalAmount)
      } else {
        prevIndex = idx - 1
        this.remainDuePayment = utilities.ParseNumber(this.listPaymentLine[prevIndex].due)
      }

      for (let index = prevIndex; index < this.listPaymentLine.length; index++) {
        let due = this.remainDuePayment
        let tendered = utilities.ParseNumber(this.listPaymentLine[index].tendered)
        let change = tendered - due
        if (change > 0) {
          this.listPaymentLine[index].change = utilities.DisplayNumber(change)
        } else {
          this.listPaymentLine[index].change = ''
        }
        this.listPaymentLine[index].due = utilities.DisplayNumber(due)

        this.remainDuePayment = due - tendered
      }
    },
    onClickPaymentNumpad(input) {
      var newbuf = ''
      let currentIndex = this.paymentLineIndex

      if (input === 'TENDERED') {
        this.buttonMode = 'TENDERED'
        let elBtnMode = document.getElementById('TENDERED')
        elBtnMode.classList.add('selected-mode')

        elBtnMode = document.getElementById('CARDNO')
        elBtnMode.classList.remove('selected-mode')

        return
      }

      if (input === 'CARDNO') {
        this.buttonMode = 'CARDNO'
        let elBtnMode = document.getElementById('CARDNO')
        elBtnMode.classList.add('selected-mode')

        elBtnMode = document.getElementById('TENDERED')
        elBtnMode.classList.remove('selected-mode')

        return
      }

      if (this.buttonMode === 'TENDERED') {
        newbuf = String(this.listPaymentLine[currentIndex].tendered)
      }

      if (this.buttonMode === 'CARDNO') {
        newbuf = String(this.listPaymentLine[currentIndex].cardno)
        if (newbuf === 'NaN') {
          newbuf = ''
        }
      }

      if (input === 'BACKSPACE') {
        if (newbuf !== '0') {
          newbuf = newbuf.substring(0, newbuf.length - 1)
        }

        if (newbuf === '') {
          newbuf = '0'
        }
      }

      if (!isNaN(parseInt(input))) {
        if (newbuf === '0') {
          newbuf = '' + input
        } else {
          newbuf += input
        }
      }

      // Update current payment line
      if (this.buttonMode === 'TENDERED') {
        this.listPaymentLine[currentIndex].tendered = utilities.DisplayNumber(utilities.ParseNumber(newbuf))
      }

      if (this.buttonMode === 'CARDNO') {
        this.listPaymentLine[currentIndex].cardno = newbuf
      }

      let due = utilities.ParseNumber(this.listPaymentLine[currentIndex].due)
      let tendered = utilities.ParseNumber(this.listPaymentLine[currentIndex].tendered)
      let change = tendered - due
      if (change > 0) {
        this.listPaymentLine[currentIndex].change = utilities.DisplayNumber(change)
      } else {
        this.listPaymentLine[currentIndex].change = ''
      }
      this.remainDuePayment = due - tendered

      // Recalculate next payment line
      for (let index = this.paymentLineIndex + 1; index < this.listPaymentLine.length; index++) {
        let due = this.remainDuePayment
        let tendered = utilities.ParseNumber(this.listPaymentLine[index].tendered)
        let change = tendered - due
        if (change > 0) {
          this.listPaymentLine[index].change = utilities.DisplayNumber(change)
        } else {
          this.listPaymentLine[index].change = ''
        }
        this.listPaymentLine[index].due = utilities.DisplayNumber(due)

        this.remainDuePayment = due - tendered
      }
    },
    onPreValidatePayment() {
      // QRIS Blank
      this.updatePOSCustomer('')

      // START - Validation
      // Check tendered amount
      let paidAmount = 0
      let returnAmount = 0
      this.listPaymentLine.forEach(item => {
        paidAmount = paidAmount + utilities.ParseNumber(item.tendered)
        returnAmount = returnAmount + utilities.ParseNumber(item.change)
      })
      if (paidAmount < utilities.ParseNumber(this.totalAmount)) {
        SweetAlert.fire('Checking Payment Amount', 'Your payment is less than the total.<br> Total amount is ' + this.totalAmount, 'error')
        return
      }

      this.onValidatePayment(paidAmount, returnAmount)
    },
    onValidatePayment(paidAmount, returnAmount, qrisId = '') {
      let me = this

      let today = new Date()
      let arrPOSSessionName = this.posSessionName.split('/')
      let orderName = arrPOSSessionName[arrPOSSessionName.length - 1].padStart(5, '0') + '-' +
                      today.getFullYear() + (today.getMonth() + 1).toString().padStart(2, '0') + today.getDate().toString().padStart(2, '0') + '-' +
                      // this.loginSeqNo.toString().padStart(5, '0') + '-' +
                      this.sessionNo.toString().padStart(5, '0')
      let documentDate = today.getDate().toString().padStart(2, '0') + '.' + (today.getMonth() + 1).toString().padStart(2, '0') + '.' + today.getFullYear()
      this.rrnNumber = qrisId !== '' || qrisId !== undefined ? qrisId.split('.')[1] : ''

      // START- Checking need create PassCode or not
      let baseAPIUrl = config.environment === 'Local' ? '/api/Gate' : '/api/Gate/' + this.$store.state.userInfo.projects[0]
      let needPassCode = []
      let reqPassCode = []

      for (let i = 0; i < this.listCart.length; i++) {
        const cart = this.listCart[i]
        const product = this.listProductAll.find((item) => {
          return item.id === cart.id
        })
        if (product.isPassCodeRelated) {
          needPassCode.push(cart)
        }
      }

      if (needPassCode.length > 0) {
        needPassCode.forEach(item => {
          for (let i = 1; i <= item.qty; i++) {
            reqPassCode.push({
              project_id: this.projectId,
              project_name: this.projectName,
              order_id: this.posSessionName + '|' + orderName,
              payment_id: this.posSessionName + '|' + orderName,
              payment_item_id: 0,
              transaction_id: this.posSessionName + '|' + orderName,
              payment_method_id: PAYMENT_METHOD_ID,
              payment_method_name: PAYMENT_METHOD_NAME,
              booking_date: moment().format(this.DATE_FORMAT),
              is_used: false,
              using_date: null,
              item_id: item.id,
              item_name: item.name
            })
          }
        })
      }
      // END- Checking need create PassCode or not

      let arrCashFlow = []
      this.listPaymentLine.forEach(item => {
        let tenderedAmount = utilities.ParseNumber(item.tendered)
        let returnAmount = utilities.ParseNumber(item.change)
        if (tenderedAmount > 0) {
          arrCashFlow.push({
            Id: 0,
            Name: orderName + '/' + 'tendered',
            TransactionDate: documentDate,
            Amount: tenderedAmount,
            CurrencyId: item.currencyId,
            OrderId: 0,
            SessionId: 0,
            PointOfSalesId: 0,
            PaymentMethodId: item.paymentMethodId,
            CardNo: item.cardno,
            QRISId: qrisId // item.qrisId
          })
        }
        if (returnAmount !== 0) {
          arrCashFlow.push({
            Id: 0,
            Name: orderName + '/' + 'return',
            TransactionDate: documentDate,
            Amount: returnAmount * -1,
            CurrencyId: item.currencyId,
            OrderId: 0,
            SessionId: 0,
            PointOfSalesId: 0,
            PaymentMethodId: item.paymentMethodId,
            CardNo: item.cardno,
            QRISId: ''
          })
        }
      })

      let arrOrderItem = []
      this.listCart.forEach(item => {
        arrOrderItem.push({
          Id: 0,
          OrderId: 0,
          ProductId: item.id,
          ProductName: item.name,
          ProductUoM: item.uom,
          BillPlanId: 0,
          BillPlanSeqNo: 0,
          Price: item.price,
          Quantity: item.qty,
          Discount: item.discount,
          Amount: item.amount,
          Tax: item.tax,
          TaxAmount: item.taxAmount,
          AmountIncludeTax: item.amount + item.taxAmount,
          CurrencyId: item.currencyId
        })
      })

      let reqData = {
        Id: 0,
        Name: orderName,
        DocumentDate: documentDate,
        CustomerId: this.customerSelectedId,
        // ProjectId: set in backend
        BillId: this.customerSelectedId,
        TotalAmount: this.subTotalAmount,
        TaxAmount: this.taxAmount,
        TotalAmountIncludeTax: this.totalAmount,
        PaidAmount: paidAmount,
        ReturnAmount: returnAmount,
        CurrencyId: arrOrderItem[0].CurrencyId,
        SessionId: this.posSessionId,
        // PointOfSalesId: set in backend
        // Status: set in backend
        NoOfPrint: 0,
        OrderItems: arrOrderItem,
        CashFlow: arrCashFlow
      }

      // Create Order
      // let sessionNo = this.sessionNo
      // let listSession = this.listSession
      // let lastSessionNo = this.lastSessionNo
      api
        .request('POS', 'post', '/api/Order/Create', reqData)
        .then(response => {
          if (response.data.returnStatus) {
            this.deleteSession(this.sessionNo)
            this.prepareReceiptData(orderName, today, returnAmount)
            this.listOrder = response.data.entity
            this.viewType = VIEW_RECEIPT
          } else {
            SweetAlert.fire('Error', response.data.returnMessage.join('<br>'), 'error')
          }

          return response.data.returnStatus
        })
        .then(isSuccess => {
          if (!isSuccess) {
            return isSuccess
          }

          if (needPassCode.length > 0) {
            let chunksReqPassCode = me.splitArrayIntoChunks(reqPassCode)

            let requests = []
            for (let i = 0; i < chunksReqPassCode.length; i++) {
              const request = api.request('Gate', 'post', baseAPIUrl + '/GeneratePassCode', chunksReqPassCode[i])
              requests.push(request)
            }

            me.passCodes = []
            axios
              .all(requests)
              .then(
                axios.spread((...response) => {
                  for (let i = 0; i < response.length; i++) {
                    for (let j = 0; j < response[i].data.entity.length; j++) {
                      me.passCodes.push(response[i].data.entity[j])
                    }
                  }
                })
              )
              .then(response => {
                for (let i = 0; i < me.passCodes.length; i++) {
                  const passCode = me.passCodes[i]

                  document.getElementById(`passCode-${passCode.id}`).innerHTML = ''
                  var qr = new window.QRCode(document.getElementById(`passCode-${passCode.id}`), {
                    width: 200,
                    height: 200
                  })
                  qr.makeCode(passCode.id + '|POSAdmin')
                }
              })
              .catch(error => {
                SweetAlert.fire('Error', error.message, 'error')
              })
          }

          // if (needPassCode.length > 0) {
          //   api
          //     .request('Gate', 'post', baseAPIUrl + '/GeneratePassCode', reqPassCode)
          //     .then(response => {
          //       let passCodes = response.data.entity
          //       me.passCodes = passCodes
          //     })
          //     .then(response => {
          //       for (let i = 0; i < me.passCodes.length; i++) {
          //         const passCode = me.passCodes[i]

          //         document.getElementById(`passCode-${passCode.id}`).innerHTML = ''
          //         var qr = new window.QRCode(document.getElementById(`passCode-${passCode.id}`), {
          //           width: 200,
          //           height: 200
          //         })
          //         qr.makeCode(passCode.id + '|POSAdmin')
          //       }
          //     })
          // }

          return isSuccess
        })
        .then(isSuccess => {
          if (!isSuccess) {
            return
          }

          this.listCart.forEach(item => {
            if (item.membershipId > 0) {
              let reqDataPaid = {
                GuestId: this.customerSelectedId,
                MembershipId: item.membershipId,
                MembershipName: item.name,
                TransferDate: documentDate,
                BankAccountNo: orderName,
                BankAccountName: 'POS System'
              }
              api
                .request('Guest', 'post', '/api/Guest/PayMembershipFromPOS', reqDataPaid)
            }
          })
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    prepareReceiptData(orderName, today, returnAmount) {
      this.changeAmount = utilities.DisplayNumber(returnAmount)

      let hours = today.getHours()
      let minutes = today.getMinutes()
      minutes = minutes < 10 ? '0' + minutes : minutes
      let seconds = today.getSeconds()
      seconds = seconds < 10 ? '0' + seconds : seconds
      let strTime = hours + ':' + minutes + ':' + seconds

      let date = today.getDate()
      let strMonth = today.getMonth()
      let numMonth = Number(strMonth)
      let month = (numMonth + 1).toString().padStart(2, '0')
      let year = today.getFullYear()
      this.orderDate = date + '/' + month + '/' + year + '  ' + strTime
      this.orderNo = orderName

      let me = this.itemReceipt = []
      this.listCart.forEach(item => {
        me.push({
          name: item.name,
          quantity: utilities.DisplayNumber(item.qty),
          uom: item.uom === 'null' ? '-' : item.uom,
          amount: utilities.DisplayNumber(item.amount),
          discount: '- ' + utilities.DisplayNumber(item.discount),
          tax: utilities.DisplayNumber(item.tax)
        })
      })
    },
    deleteSession(sessionNo) {
      for (var i = 0; i < this.listSession.length; i++) {
        if (this.listSession[i].no === sessionNo) {
          this.listSession.splice(i, 1)
        }
      }
      this.updateLocalStorage()
    },
    onChooseOrder(data, idx) {
      this.orderData.name = data.name
      this.orderData.documentDate = data.documentDate
      this.orderData.amount = data.totalAmountIncludeTax
      this.orderData.returnAmount = data.returnAmount
      this.orderData.paidAmount = data.paidAmount
      this.orderData.status = data.status
      this.orderIndex = idx

      this.textButtonSetOrder = 'Set RePrint'
    },
    onDisplayScreenOrder(previousView) {
      this.previousView = previousView
      this.textButtonSetOrder = this.orderSelectedId ? 'Deselect RePrint' : 'Set RePrint'

      if (this.orderSetIndex) {
        this.orderIndex = this.orderSetIndex
        this.orderData.name = this.listOrder.name
        this.orderData.amount = this.listOrder.totalAmountIncludeTax
        this.orderData.documentDate = this.listOrder.documentDate
        this.orderData.status = this.listOrder.status
      }
      this.inquiryParam.WhereClauseOrder = 'ProjectId = ' + this.projectId + (this.previousView === 'initial' ? '' : ' and ' + this.previousView)
      console.log(this.inquiryParam.WhereClauseOrder)
      this.inquiryParam.PageSize = '100'
      this.inquiryParam.SortExpression = 'DocumentDate'
      this.inquiryParam.SortDirection = 'DESC'
      api
        .request('POS', 'get', '/api/Order/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseOrder +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listOrder = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })

      this.viewType = VIEW_ORDER
    },
    onSearchOrder(evt) {
      var keyWords = evt.target.value
      var whereClause = ['Name', 'like', '\'' + keyWords + '%\'', 'or', 'DocumentDate', 'like', '\'' + keyWords + '%\'']
      var params = '(' + whereClause.join(' ') + ')'
      this.onDisplayScreenOrder(params)
    },
    onRePrint() {
      if (this.textButtonSetOrder === 'Set RePrint') {
        this.orderSetIndex = this.orderIndex
        this.orderSelectedId = this.listOrder[this.orderSetIndex].id
        this.changeAmount = utilities.DisplayNumber(this.listOrder[this.orderSetIndex].returnAmount)
        this.subTotalAmount = this.displayNumber(this.listOrder[this.orderSetIndex].totalAmount)
        this.taxAmount = this.displayNumber(this.listOrder[this.orderSetIndex].taxAmount)
        this.totalAmount = this.displayNumber(this.listOrder[this.orderSetIndex].totalAmountIncludeTax)

        this.orderDate = this.orderData.documentDate
        this.orderNo = this.orderData.name
        this.listOrder = this.listOrder[this.orderSetIndex]
        api
          .request('POS', 'get', '/api/Order/GetItem?Id=' + this.orderSelectedId, null)
          .then(response => {
            var data = response.data
            this.listCart = data.entity
            let me = this.itemReceipt = []
            this.listCart.forEach(item => {
              me.push({
                name: item.productName,
                quantity: utilities.DisplayNumber(item.quantity),
                uom: item.productUoM === 'null' ? '-' : item.productUoM,
                amount: utilities.DisplayNumber(item.amount),
                discount: '- ' + utilities.DisplayNumber(item.discount),
                tax: utilities.DisplayNumber(item.tax)
              })
            })
            this.viewType = VIEW_RECEIPT
          })
      }
    },
    onPrintReceipt() {
      var divContents = document.getElementById('printableArea').innerHTML
      // var a = window.open('', '', 'height=300px, width=200px')
      var w = window.open()
      w.document.write('<html>')
      w.document.write('<body style="width:195px; margin-left:0px; margin-right:0px; padding-right:20px;">')
      w.document.write(divContents)
      w.document.write('</body></html>')
      w.print()
      w.close()

      // var w = window.open()
      // w.document.write($('#printableArea').html())
      // w.print()
      // w.close()

      // var printContents = document.getElementById('printableArea').innerHTML
      // var originalContents = document.body.innerHTML

      // document.body.innerHTML = printContents

      // window.print()

      // document.body.innerHTML = originalContents
      // window.print()
    },
    onPrintReceiptMember(row) {
      let customer
      let project
      let company

      // Get Customer Name and NPWP
      api
        .request('Guest', 'get', '/api/Guest/GetDetail?Id=' + row.customerId, null)
        .then(response => {
          customer = response.data.entity
        })
        .then(response => {
          // Get Project Detail
          api
            .request('Account', 'get', '/api/Project/GetDetail?Id=' + row.projectId, null)
            .then(response => {
              project = response.data.entity
            })
            .then(response => {
              // Get Company Detail
              api
                .request('Account', 'get', '/api/Company/GetDetail?Id=' + project.companyId, null)
                .then(response => {
                  company = response.data.entity
                })
                .then(response => {
                  // Main  Process
                  // var params = {
                  //   Id: row.id,
                  //   Name: row.name,
                  //   DocumentDate: row.documentDate,
                  //   TaxReceiptNo: row.taxReceiptNo,
                  //   TotalAmount: row.totalAmount,
                  //   PaymentMethod: row.paymentMethod,
                  //   PaymentDate: row.paymentDate,
                  //   CustomerName: customer.firstName + ' ' + customer.lastName,
                  //   CustomerAddress1: customer.address1,
                  //   CustomerAddress2: customer.address2,
                  //   CustomerNPWP: customer.NPWP,
                  //   ProjectName: project.name,
                  //   ProjectLocation: project.city,
                  //   CompanyName: company.name,
                  //   CompanyAddress1: company.address1,
                  //   CompanyAddress2: company.address2,
                  //   OrderItems: this.listCart
                  // }
                  var params = 'OrderName=' + row.name + ';V_CUSTOMER_NAME=' + customer.firstName + ' ' + customer.lastName
                  params = params + ';V_CUSTOMER_ADDRESS1=' + (customer.address1 === null ? '' : customer.address1) + ';V_CUSTOMER_ADDRESS2=' + (customer.address2 === null ? '' : customer.address2) + ';V_NPWP=' + (customer.npwp === null ? '' : customer.npwp)
                  params = params + ';V_COMP_NAME=' + (company.name === null ? '' : company.name) + ';V_COMP_ADDR1=' + (company.address1 === null ? '' : company.address1) + ';V_COMP_ADDR2=' + (company.address2 === null ? '' : company.address2) + ';V_PROJ_LOC=' + (project.city === null ? '' : project.city)
                  api.request('POS', 'get', '/api/POS/PrintReports?fileReports=emembers_reports/kwitansi.pdf&paramsReports=' + params, null, 'blob')
                    .then(response => {
                      const objUrl = window.URL.createObjectURL(response.data)
                      const iframe = window.$('#viewer')[0]
                      iframe.setAttribute('src', objUrl + '#toolbar=0&navpanes=1&scrollbar=0&view=Fit')
                      window.$('#modal-view-file').modal('show')
                      window.URL.revokeObjectURL(objUrl)
                    })
                })
            })
        })
    },
    onPrintPdf() {
      const iframe = window.$('#viewer')[0]
      iframe.focus()
      iframe.contentWindow.print()
    },
    splitArrayIntoChunks(array, chunkSize = 10) {
      let result = []
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize))
      }
      return result
    }
  }
}
</script>

<style scoped>
/* --- Fonts --- */
@font-face{
    font-family: 'Inconsolata';
    src: url('/static/fonts/Inconsolata.otf') format('otf');
}

.modal-dialog-qris {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height:100%;
    background-color: rgba(0,0,0,0.5);
    z-index:1000;
}

.modal-dialog-qris .popup{
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    margin: auto;
    width:650px;
    height:550px;
    text-align:center;
    font-size:20px;
    font-weight:bold;
    background-color: #F0EEEE;
    border-radius: 3px;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.4);
    z-index:1200;
    font-family: 'Lato';
    font-family: Lato;
}

.modal-dialog-qris .popup .qris{
    display: inline-flex;
}

/* --- Styling of OpenERP Elements --- */
.ui-dialog, .modal-dialog {
    background: white;
    padding: 10px;
    border-radius: 3px;
    font-family: sans-serif;
    box-shadow: 0px 10px 40px rgba(0,0,0,0.4);
    position: absolute;
    top: 30px;
    width: 800px;
    height: 400px;
    overflow: scroll;
}
.ui-dialog button, .modal-dialog button {
    padding: 8px;
    min-width: 48px;
}
.ui-dialog .ui-icon-closethick{
    float: right;
}
div.modal.in {
    position: absolute;
    background: white;
    padding: 20px;
    box-shadow: 0px 10px 20px black;
    border-radius: 3px;
    max-width: 600px;
    max-height: 400px;
    margin-top: -200px;
    margin-left: -300px;
    top: 50%;
    left: 50%;
}

/* --- Generic Restyling and Resets --- */

html {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: sans-serif;
}

table {
    border-spacing: 0px;
    border-collapse: collapse;
}
td {
    padding: 0px;
}

.oe_hidden{
    display: none !important;
}
.oe_invisible{
    visibility: hidden !important;
}
.clearfix:after {
    content:" ";
    display: block;
    visibility: hidden;
    line-height: 0;
    height: 0;
    clear: both;
}


.pos input::-webkit-outer-spin-button,
.pos input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.pos button{
    box-shadow: none;
    outline: none;
    border: none;
    font-family: 'Lato';
}
.pos button:hover{
    background: default;
}
.pos textarea {
    font-family: "Lato";
    font-size: 20px;
    color: #444;
    padding: 10px;
    border-radius: 3px;
    border: none;
    box-shadow: 0px 0px 0px 1px rgb(220,220,220) inset;
}
.pos textarea:focus {
    outline: none;
    box-shadow: 0px 0px 0px 3px #6EC89B;
}


.pos .oe_hidden{
    display: none !important;
}

.pos ul, .pos li  {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.pos {
    padding: 0;
    margin: 0;
    background-color: #f0eeee;
    font-family: "Lato","Lucida Grande", Helvetica, Verdana, Arial;
    color: #555555;
    font-size: 12px;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    text-shadow: none;
    overflow: hidden;
}

/*  ********* The black loading screen ********* */

.pos .loader{
    background-color: #222;
    position:absolute;
    left:0px;
    top:0px;
    width:100%;
    height:100%;
    z-index: 999;
    text-align: center;
    font-family: Lato;
    color: #555555;
}

.pos .loader-feedback{
    width: 400px;
    height: 160px;
    margin: -60px -200px;
    position: absolute;
    left: 50%; top: 50%;
    text-align: center;
}
.pos .loader-feedback h1{
    font-weight: 300;
}
.pos .loader-feedback .progressbar{
    background: rgb(73,73,73);
    height: 1px;
}
.pos .loader-feedback .progressbar > .progress{
    height: 100%;
    background: white;
    width: 0%;
    box-shadow: 0px 0px 5px rgba(255,255,255,0.35);
}
.pos .loader-feedback .button{
    display: inline-block;
    margin: 25px auto;
    line-height: 42px;
    padding: 0px 16px;
    font-size: 20px;
    font-weight: 300;
    border: solid 1px;
    border-radius: 5px;
    cursor: pointer;
}
.pos .loader-feedback .button:active{
    color: #222;
    background: #555555;
}
/*  ********* Generic Layout Constructs  ********* */

.pos .window{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: table;
    border: none;
    overflow: hidden;
}
.pos .window .subwindow{
    display: table-row;
    width: 100%;
    height: 100%;
}
.pos .window .subwindow.collapsed{
    height: 0px;
}
.pos .window .subwindow-container .collapsed{
    height: 0px;
}
.pos .subwindow .subwindow-container{
    display: table-cell;
    position: relative;
}
/* firefox seems to ignore the relative positionning of the subwindow-container
 * putting this inside subwindow-container fixes it.
 */ 
.pos .subwindow .subwindow-container-fix{
    height: 100%;
    position: relative;
}

.pos .clientlist-screen .window,
.pos .clientlist-screen .full-content .subwindow{
    display: block;
}
.pos .clientlist-screen .full-content .subwindow-container{
    display: block;
    height: 100%;
}
.pos .clientlist-screen .full-content .subwindow.collapsed,
.pos .clientlist-screen .full-content .subwindow-container.collapsed{
    height: auto;
}

/* ---- Scrollers ----- */

.pos .scroller-container{
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
}
.pos .scroller{
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.pos .scroller.horizontal{
    overflow-y: hidden;
    overflow-x: auto;
}
.pos .scroller-content{
    -webkit-transform: translate3d(0,0,0);
}
.pos .scroller-container ::-webkit-scrollbar{
    width:  10px;
    height: 10px;
}
.pos .scroller-container ::-webkit-scrollbar-track{
    background: rgb(224,224,224);
    border-left: solid 1px rgb(200,200,200);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.pos .scroller-container ::-webkit-scrollbar-thumb{
    background: rgb(168,168,168);
    min-height: 30px;
}

/*  ********* Generic element styling  ********* */

.pos a {
    text-decoration: none;
    color: #555555;
}
.pos button, .pos a.button {
    display: inline-block;
    cursor: pointer;
    padding: 4px 10px;
    font-size: 11px;
    border: 1px solid #cacaca;
    background: #e2e2e2;
    border-radius: 3px;
}
.pos ul, .pos ol {
    padding: 0;
    margin: 0;
}
.pos li {
    list-style-type: none;
}
.pos .pos-right-align {
    text-align: right;
}
.pos .pos-center-align {
    text-align: center;
}
.pos .pos-disc-font {
    font-size: 12px;
    font-style:italic;
    color: #808080;
}

/*  ********* The black header bar ********* */


.pos .pos-topheader {
    position:absolute;
    left:0;
    top:0;
    width: 100%;
    height: 48px;
    margin:0;
    padding:0;
    color: gray;
    background: #393939;
}

/*  a) The left part of the top-bar */

.pos .pos-branding{
    position: absolute;
    display: table-cell;
    left:0;
    top:0;
    width:439px;
    height:100%;
    margin:0;
    padding:0;
    border-right: 1px solid #373737;
    text-align:left;
    line-height:100%;
    vertical-align: middle;
}
.pos .pos-logo {
    height: 35px;
    margin-left: 7px;
    margin-top: 2px;
    vertical-align:middle;
} 
.pos .pos-branding .username{
    float:right;
    color:#DDD;
    font-size:16px;
    margin-right:32px;
    line-height: 48px;
    font-style:italic;
    cursor: pointer;
}

/*  b) The right part of the top-bar */

.pos .pos-rightheader {
    position: absolute;
    left:440px;
    right:0;
    top:0;
    height:100%;
    display: -webkit-flex;
    display: flex;
}
.pos .pos-rightheader > * {
    border-right: 1px solid #292929;
}

.pos .order-button{
    color: #f0f0f0;
    display: inline-block;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    height: 46px;
    padding: 4px 8px;
    margin: 3px;
    margin-bottom: 0px;
    margin-right: 2px;
    padding-top: 0px;
    background: #8b8b8b;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    vertical-align: top;
    line-height: 42px;
    text-align: center;
    box-shadow: 0px -5px 10px -6px rgb(82,82,82) inset;
    cursor: pointer;
    min-width: 45px;
}

.pos .order-button:first-child {
    margin-left: 0px;
}

.pos .order-button.selected{
    font-weight: 900;
    background: #EEEEEE;
    color: rgb(75,75,75);
    height: 45px;
    border-bottom: solid 1px rgb(196, 196, 196);
    box-shadow: none;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
}

.pos .order-button .order-sequence{
    font-size: 16px;
    font-weight: 800;
    vertical-align: middle;
}
.pos .order-button.selected .order-sequence{
    color: white;
    background: black;
    display: inline-block;
    line-height: 24px;
    min-width: 24px;
    border-radius: 12px;
    margin-right: 4px;
    margin-left: -4px;
}

.pos .order-button.square{
    margin-left:1px;
    background: #5c5c5c;
    color: rgb(160,160,160);
    font-size: 18px;
    line-height: 45px;
}
.pos .order-button:not(.square) > .fa {
    font-size: 16px;
    vertical-align: middle;
    margin-right: 4px;
}
.pos .order-button .order-sequence{
    font-size: 16px;
    font-weight: 800;
}

.pos .order-selector {
    display: -webkit-flex;
    display: flex;
    -webkit-flex: 1;
    flex: 1;
}
.pos .orders {
    display: -webkit-flex;
    display: flex;
    vertical-align: top;
    margin-left: 0px;
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

/*  c) The session buttons */

.pos .pos-rightheader .header-button{
    float: right;
    height: 48px;
    padding-left: 16px;
    padding-right: 16px;
    border-right: 1px solid #292929;
    border-left: 1px solid #292929;
    color: #DDD;
    line-height: 48px;
    text-align: center;
    cursor: pointer;

    -webkit-transition-property: background;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-out;
}
.pos .pos-rightheader .header-button:last-child{
    border-left:  1px solid #3a3a3a;
}
.pos .pos-rightheader .header-button:active{
    background: rgba(0,0,0,0.2);
    color:#EEE;
}
.pos .pos-rightheader .header-button.confirm {
    background: #359766;
    color: white;
    font-weight: bold;
}

/*  c) The notifications indicator */

.pos .oe_status{
    float:right; 
    color: rgba(255,255,255,0.4);
    padding: 14px;
    line-height: 20px;
    font-size: 20px;
    vertical-align:middle;
    font-style: italic;
    cursor:pointer;
}
.pos .oe_status.oe_inactive{
    cursor: default;
}
.pos .oe_status .oe_icon{
    display:inline-block;
    cursor:pointer;
    width:20px; height:16px;
    color: white;
}
.pos .oe_status .oe_red,
.pos .oe_icon.oe_red {
    color: rgb(197, 52, 0);
}
.pos .oe_statu .oe_green,
.pos .oe_icon.oe_green {
    color: rgb(94, 185, 55);
}
.pos .oe_status .oe_orange,
.pos .oe_icon.oe_orange {
    color: rgb(239, 153, 65);
}
.pos .oe_link_icon{
    cursor:pointer;
}
/*  ********* Contains everything below the  bar ********* */

.pos .pos-content {
    width: 100%;
    position: absolute;
    top: 48px;
    bottom: 0;
    background: #F0EEEE;
}

/*  ********* The leftpane contains the order, numpad and paypad ********* */

.pos .leftpane {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    position:absolute;
    left:0;
    width:440px;
    top:0px;
    bottom:0;
    border-right: solid 1px #CECBCB;
    border-right: solid 3px #787878;
    background: #e2e2e2;
}

.pos .leftpane .pads {
    border-top: solid 3px rgb(110, 200, 155);
}

/*  ********* The control buttons ********* */

.pos .control-buttons {
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
    padding: 8px 16px 0px 11px;
    margin-bottom: -6px;
}
.pos .control-button {
    -webkit-flex-grow: 1;
    flex-grow: 1;
    background: #e2e2e2;
    border: solid 1px #bfbfbf;
    display: inline-block;
    line-height: 38px;
    min-width: 80px;
    text-align: center;
    border-radius: 3px;
    padding: 0px 10px;
    font-size: 18px;
    margin-left: 6px;
    margin-bottom: 6px;
    cursor: pointer;
    overflow: hidden;
    transition: all linear 150ms;
}
.pos .control-button:hover {
    background: #efefef;
}
.pos .control-button:active {
    background: black;
    color: white;
    border-color: black;
}
.pos .control-button .fa{
    margin-right: 4px;
}
.pos .control-button .control-button-number {
    color: rgb(226, 226, 226);
    background: rgb(85, 85, 85);
    display: inline-block;
    height: 28px;
    vertical-align: middle;
    font-weight: bold;
    line-height: 28px;
    width: 28px;
    border-radius: 50%;
    text-align: center;
    margin-left: -16px;
    margin-right: 4px;
}

.pos .control-button.highlight,
.pos .button.highlight {
    background: #6EC89B !important;
    border: solid 1px #64AF8A !important; 
    color: white !important;
}
.pos .control-button.altlight,
.pos .button.altlight {
    background: #7F82AC !important;
    border: solid 1px #756A99 !important;
    color: white !important;
}
.pos .control-button.disabled,
.pos .control-button.disabled:active{
    background: #e2e2e2;
    border: solid 1px #BEBEBE;
    opacity: 0.5;
    cursor: default;
    color: inherit;
}

/*  ********* The actionpad (payment, set customer) ********* */

.pos .actionpad {
    display: inline-block;
    float: left;
    padding: 0;
    margin: 16px;
    margin-top: 8px;
    margin-right: 0;
    text-align: center;
    vertical-align: top;
    width: 186px;
    border: none;
    border-radius: 0;
    border-top: 1px solid;
    border-left: 1px solid;
    border-color: #bfbfbf;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}
.pos .actionpad .button {
    position: relative;
    display: block;
    height: 54px;
    width: 100%;
    font-weight: bold;
    vertical-align: middle;
    color: #555555;
    font-size: 14px;
    border-radius: 0;
    border: none;
    border-right: 1px solid;
    border-bottom: 1px solid;
    border-color: #bfbfbf;
    transition: all 150ms linear;
}
.pos .actionpad .button:hover {
    background: #efefef;
}
.pos .actionpad .button:active {
    background: black;
    border-color: black;
    color: white;
}
.pos .actionpad .button:first-child {
    border-top-left-radius: 4px;
}
.pos .actionpad .button:last-child {
    border-bottom-left-radius: 4px;
}
.pos .actionpad .button.pay {
    height: 162px;
}
.pos .actionpad .button.pay .pay-circle {
    display: block;
    font-size: 32px;
    line-height: 54px;
    padding-top: 6px;
    background: rgb(86, 86, 86);
    color: white;
    width: 60px;
    margin: auto;
    border-radius: 30px;
    margin-bottom: 10px;
}
.pos .actionpad .button.pay .pay-circle .fa {
    position: relative;
    top: -1px;
    left: 3px;
}

.pos .actionpad .button.set-customer{
    padding-left: 40px;
    padding-right: 40px;
}
.pos .actionpad .button.set-customer.decentered {
    padding-left: 40px;
    padding-right: 5px;
}
.pos .actionpad .button .fa-user {
    position: absolute;
    left: 13px;
    top: 13px;
    margin-right: 8px;
    font-size: 18px;
    background: rgba(255, 255, 255, 0.5);
    line-height: 30px;
    width: 30px;
    border-radius: 100%;
}

/*  ********* The Numpad ********* */

.pos .numpad {
    display: inline-block;
    float: right;
    text-align: center;
    width: 216px;
    margin: 16px;
    margin-top: 8px;
    margin-left: 0px;
    border: none;
    border-radius: 0;
    border-top: 1px solid;
    border-color: #bfbfbf;
    border-top-right-radius: 4px;
}
.pos .numpad button {
    float: left;
    height: 54px;
    width: 54px;
    font-weight: bold;
    vertical-align: middle;
    color: #555555;
    border-radius: 0;
    border: none;
    border-right: 1px solid;
    border-bottom: 1px solid;
    border-color: #bfbfbf;
    transition: all 150ms linear;
}
.pos .numpad button:hover {
    background: #efefef;
}
.pos .numpad button:active {
    background: black;
    color: white;
    border-color: transparent;
}
.pos .numpad button:nth-child(4) {
    border-top-right-radius: 4px;
}
.pos .numpad button:last-child {
    border-bottom-right-radius: 4px;
}
.pos .input-button {
    font-size: 24px;
}
.pos .mode-button {
    font-size: 14px;
}
.pos .mode-button.selected-mode {
    color: white;
    background: #6EC89B;
    border-color: transparent;
}
.pos .mode-button.selected-mode:hover {
    background: #6EC89B;
    color: white;
    border-color: transparent;
}
.pos .numpad .disabled-mode, .pos .numpad .disabled-mode:hover {
    background: #c7c7c7;
    color: #a5a1a1;
    cursor: not-allowed;
}

/*  ********* The right pane contains the screens and headers ********* */

.pos .rightpane {
    position: absolute;
    top: 0;
    bottom:0;
    left: 440px;
    right: 0;
    vertical-align: top;
    -webkit-transform: translate3d(0,0,0);
}

.pos .rightpane-header {
    padding: 0;
    height: 48px;
    border-bottom: 1px solid #c7c7c7;
    background: #d3d3d3;
    text-align: center;
}

/*  ********* The product list  ********* */

.pos .product-list {
    padding: 10px;
    text-align: left;
    -webkit-transform: translate3d(0,0,0);
}

.pos .product-list-scroller{
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    width:100%;
    height:100%;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);

}
.pos .product-list-container {
    position:absolute;
    top:0px;
    bottom:0px;
    left:0px;
    right:0px;
}

/*  a) the product list navigation bar */

.pos .breadcrumbs{
    display: inline-block;
    text-align: left;
    float:left;
}
.pos .breadcrumb-pos{
    float: left;
    display: inline-block;
    line-height: 48px;
    height: 48px;
    min-width: 48px;
}
.pos .breadcrumb-pos:last-child {
    padding-right: 3px;
    border-right: 1px solid #c5c5c5;
}
.pos .breadcrumb-button {
    display: inline-block;
    padding: 0 9px;
    vertical-align: top;
    color: #808080;
    font-size: 14px;
    cursor: pointer;
}
.pos .breadcrumb-button.breadcrumb-home {
    line-height: 50px;
    padding: 0;
    width: 50px;
    font-size: 25px;
    text-align: center;
}

.pos .breadcrumb-arrow{
    width: 28px;
}
.pos .breadcrumb-homeimg {
    width: 27px;
    margin: 12px 6px;
}

/*  b) the search box */

.pos .searchbox {
    position: absolute;
    right: 2px;
}
.pos .searchbox input {
    width: 120px;
    border: 1px solid #cecbcb;
    padding: 10px 20px;
    padding-left: 38px;
    margin: 6px;
    background: url('img/search.png') no-repeat 15px;
    background-color: white;
    border-radius: 20px;
    font-family: "Lato","Lucida Grande", Helvetica, Verdana, Arial;
    font-size: 13px;
}
.pos .searchbox input:focus {
    outline: none;
    box-shadow: 0px 0px 0px 2px rgb(153, 153, 255) inset;
    color: rgb(153, 153, 255);
}
.pos .search-clear {
    position: absolute;
    width: 30px;
    height: 30px;
    top: 11px;
    left: 11px;
    cursor: pointer;
}

/*  c) the categories list */

.pos .categories {
    position: relative;
    border-bottom: solid 3px rgb(110, 200, 155);
}
.pos .categories h4 {
    display: inline-block;
    margin: 9px 5px;
}
.pos .category-list-scroller{
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    width:100%;
    height:100%;
    max-height:60vh;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    -webkit-transform: translate3d(0,0,0);

}
.pos .category-list {
    text-align: left;
    padding: 10px;
    background: rgb(229, 229, 229);
    border-bottom: 1px solid #cecece;
}
.pos .category-list.simple {
    padding: 0px;
    background: #cecece;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-flow: row wrap;
    flex-flow: row wrap;
    border-bottom: none;
}


/*  d) the category button */

.pos .category-button {
    position: relative;
    vertical-align: top;
    display: inline-block;
    font-size: 11px;
    margin: 8px !important;
    width: 120px;
    height:120px;
    background:#fff;
    border: 1px solid #d7d7d7;
    border-radius: 3px;
    border-bottom-width: 3px;
    cursor: pointer;
}

.pos .category-simple-button{
    position: relative;
    display: inline-block;
    font-size: 14px;
    margin-right: 1px;
    margin-bottom: 1px;
    padding: 5px 12px;
    line-height: 32px;
    flex-grow: 1;
    -webkit-flex-grow: 1;
    cursor: pointer;
    background: #e2e2e2;
}
.pos .category-simple-button:active{
    color: white;
    background: black;

    -webkit-transition-property: background, border;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-out;
}



.pos .category-button .category-img {
    position: relative;
    width: 120px;
    height: 100px;
    text-align: center;
    cursor: pointer;
}

.pos .category-button .category-img img {
    max-height: 100px;
    max-width:  120px;
    vertical-align: middle;
}

.pos .category-button .category-name {
    position: absolute;
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    bottom: 0;
    top: auto;
    line-height: 14px;
    width: 100%;
    /* for some reason the -90deg orientation doesn't match the -webkit-linear-gradient. It should be 180deg here.
     * webkit also insists on rendering *both* gradients instead of only the native one. So it doesn't looks right. ugh. 
    background:         linear-gradient(-90deg,rgba(255,255,255,0),rgba(255,255,255,1), rgba(255,255,255,1)); */
    /*background:#FFF;*/
    padding: 3px;
    padding-top: 15px;
    color: #7C7BAD;
}

/*  e) the product */

.pos .product {
    position:relative;
    vertical-align: top;
    display: inline-block;
    line-height: 100px;
    font-size: 14px;
    margin: 8px !important;
    width: 122px;
    height:115px;
    background:#fff;
    border: 1px solid #e2e2e2;
    border-radius: 3px;
    border-bottom-width: 3px;
    overflow: hidden;
    cursor: pointer;
}

.pos .product .product-img {
    position: relative;
    width: 120px;
    height: 100px;
    background: white;
    text-align: center;
}

.pos .product .product-img img {
    max-height: 100px;
    max-width:  120px;
    vertical-align: middle;
}

.pos .product .price-tag {
    position: absolute;
    top: 2px;
    right: 2px;
    vertical-align: top;
    color: white;
    line-height: 13px;
    background: #7f82ac;
    padding: 2px 5px;
    border-radius: 2px;
}

.pos .product .product-name {
    position: absolute;
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    bottom:0;
    top:auto;
    line-height: 14px;
    width:100%;
    overflow: hidden;
    text-overflow: ellipsis;
    background: -webkit-linear-gradient(-90deg,rgba(255,255,255,0),rgba(255,255,255,1), rgba(255,255,255,1));
    background:    -moz-linear-gradient(-90deg,rgba(255,255,255,0),rgba(255,255,255,1), rgba(255,255,255,1));
    background:     -ms-linear-gradient(-90deg,rgba(255,255,255,0),rgba(255,255,255,1), rgba(255,255,255,1));
    /* troublesome in latest webkit
    background:         linear-gradient(-90deg,rgba(255,255,255,0),rgba(255,255,255,1), rgba(255,255,255,1));
    */
    /*background:#FFF;*/
    padding: 3px;
    padding-top:15px;
}


/*  ********* The Screens  ********* */

.pos .screen {
    position:absolute;
    text-align: center;
    top:0px;
    bottom:0px;
    width:100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
.pos .screen header h2 {
    margin-top: 0px;
    padding-top: 7px;
}
.pos .screen p{
    font-size: 18px;
}
.pos .dialog{
    width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
    text-align: center;
}
.pos .dialog p{
    font-size: 25px;
    margin-top: 10px;
    color: #5a5a5a;
}

/* a) Generic Screen Layout Constructs */

.screen .screen-content{
    margin: 0px auto;
    max-width: 1024px;
    text-align: left;
    height: 100%;
    overflow: hidden;
    position: relative;
}

@media screen and (min-width: 1024px) {
    .screen .screen-content{
        border-left:  dashed 1px rgb(215,215,215);
        border-right: dashed 1px rgb(215,215,215);
    }
}

.screen .top-content{
    position: absolute;
    left: 0px; top: 0px; right: 0px;
    height: 64px;
    border-bottom: dashed 1px rgb(215,215,215);
    text-align: center;
}
.screen .top-content .button {
    position: absolute;
    top: 0px;
    line-height: 32px;
    padding: 3px 13px;
    font-size: 20px;
    background: rgb(230, 230, 230);
    margin: 12px;
    border-radius: 3px;
    border: solid 1px rgb(209, 209, 209);
    cursor: pointer;
    transition: all 150ms linear;
}
.screen .top-content .button:hover {
    background: #efefef;
}
.screen .top-content .button:active {
    background: black;
    border-color: black;
    color: white;
}
.screen .top-content .button.highlight {
    background: rgb(110,200,155);
    color: white;
    border: solid 1px rgb(110,200,155);
}
.screen .top-content .button.highlight:hover {
    background: rgb(120,210,165);
}
.screen .top-content .button.back {
    left: 0px;
    margin-left: 16px;
}
.screen .top-content .button.next{
    right: 0px;
    margin-right: 16px;
}
.screen .left-content{
    position: absolute;
    left:0px; top: 64px; bottom: 0px;
    right:50%;
    overflow-x: hidden;
    overflow-y: auto;
    border-right: dashed 1px rgb(215,215,215);
}
.screen .left-content.pc40{
    right: 85%;
}
.screen .right-content{
    position: absolute;
    right:0px; top: 64px; bottom: 0px;
    left:50%;
    overflow-x: hidden;
    overflow-y: auto;
}
.screen .right-content.pc60{
    left:15%;
}
.screen .centered-content{
    position: absolute;
    right:25%; top: 64px; bottom: 0px;
    left:25%;
    border-right: dashed 1px rgb(215,215,215);
    border-left: dashed 1px rgb(215,215,215);
    overflow-x: hidden;
    overflow-y: auto;
}
.screen .full-content{
    position: absolute;
    right: 0%; top: 65px; bottom: 0px;
    left: 0%;
}

/* a) Layout for the Product Screen */

.pos .screen .layout-table {
    border:none;
    width:100%;
    height:100%;
}

.pos .screen .header-row {
    border:none;
    width:100%;
    height:0px;
}

.pos .screen .header-cell{
    border:none;
    width:100%;
    height:0px;
}
.pos .screen .content-row {
    width:100%;
    height:100%;
}
.pos .screen .content-cell{
    width:100%;
}
.pos .screen .content-cell .content-container{
    height:100%;
    position:relative;
}


/* b) The payment screen */

.pos .payment-numpad {
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
    padding: 16px;
    text-align: center;
    float: left;
}
.pos .payment-numpad .numpad {
    float: none;
    border-radius: 4px;
    border-top: 1px solid;
    border-left: 1px solid;
    border-color: #cacaca;
    width: 400px;
    overflow: hidden;
    margin: 0;
}
.pos .payment-numpad .numpad button {
    width: 100px;
    height: 100px;
}
.pos .payment-numpad .numpad button:first-child {
    border-top-left-radius: 4px;
}
.pos .payment-numpad .numpad button:nth-child(16) {
    border-bottom-left-radius: 4px;
}

.pos .paymentlines-container {
    padding: 16px;
    padding-top: 0;
    border-bottom: dashed 1px gainsboro;
    min-height: 154px;
}

.pos .paymentlines {
    width: 100%;
}
.pos .paymentlines .controls {
    width: 40px;
}
.pos .paymentlines .label > * {
    font-size: 16px;
    padding: 8px;
}
.pos .paymentlines tbody{
    background: white;
    border-radius: 3px;
}
.pos .paymentline{
    font-size: 16px;
}
.pos .paymentline.selected {
    font-size: 16px;
    background: #6EC89B;
    color: white;
}
.pos .paymentline.selected .edit {
    background: white;
    color: #6EC89B;
    outline: 3px blue;
    box-shadow: 0px 0px 0px 3px #6EC89B;
    position: relative;
    border-radius: 3px;
}
.pos .paymentline > *{
    padding: 8px 12px;
}
.pos .paymentline .col-due,
.pos .paymentline .col-tendered,
.pos .paymentline .col-change {
    min-width: 90px;
}
.pos .paymentline.extra .col-due {
    border-radius: 0 0 6px 6px;
    border-top: solid 1px rgb(230, 230, 230);
    font-weight: bold;
}
.pos .paymentline .col-change.highlight {
    background: rgb(184, 152, 204);
}
.pos .paymentline .col-name {
    font-size: 16px;
}
.pos .paymentline .delete-button{
    cursor: pointer;
    text-align: center;
}
.pos .payment-buttons {
    display: inline-block;
    width: 30%;
    box-sizing: border-box;
    padding: 16px;
    padding-left: 0;
    float: right;
}
.payment-screen .payment-buttons .button {
    background: #e2e2e2;
    line-height: 73px;
    font-size: 16px;
    padding: 0px 8px;
    border: solid 1px rgb(200,200,200);
    border-top-width: 0;
    cursor: pointer;
    text-align: center;
    position: relative;
    transition: background-color, border-color, color 150ms linear;
}
.payment-screen .payment-buttons .button:hover {
    background-color: #efefef;
}
.payment-screen .payment-buttons .button:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-top-width: 1px;
}
.payment-screen .payment-buttons .button:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}
.payment-screen .payment-buttons .button.highlight:not(:first-child) {
    margin-top: -1px;
    border-top: solid 1px;
}
.payment-screen .payment-buttons .button:active {
    background: black;
    border-color: black;
    color: white;
}
.payment-screen .payment-buttons .button.highlight .fa {
    border-color: rgba(0, 0, 0, 0.109804);
    background: rgba(0, 0, 0, 0.0980392);
}
.payment-screen .payment-buttons .button .fa {
    position: absolute;
    left: 11px;
    top: 50%;
    width: 48px;
    height: 48px;
    line-height: 48px;
    margin-top: -25px;
    vertical-align: middle;
    border-radius: 26px;
    border: 1px solid rgba(0,0,0,0.2);
    border-image-source: initial;
    border-image-slice: initial;
    border-image-width: initial;
    border-image-outset: initial;
    border-image-repeat: initial;
    background: rgba(255,255,255,0.4);
    font-size: 20px;
    transition: all 150ms linear;
}
.payment-screen .paymentlines-empty .total {
    text-align: center;
    padding: 24px 0px 18px;
    font-size: 64px;
    color: #43996E;
    text-shadow: 0px 2px white, 0px 2px 2px rgba(0, 0, 0, 0.27);
}
.payment-screen .paymentlines-empty .message {
    text-align: center;
}


/* c) The receipt screen */

.pos .receipt-screen .centered-content .button {
    line-height: 40px;
    padding: 3px 8px;
    font-size: 15px;
    text-align: center;
    background: rgb(230, 230, 230);
    margin: 16px;
    margin-bottom: 0px;
    border-radius: 3px;
    border: solid 1px rgb(209, 209, 209);
    cursor: pointer;
}

.pos .pos-receipt-container {
    font-size: 0.75em;
    text-align: center;
}

.pos .pos-sale-ticket {
    text-align: left;
    width: 210px;
    background-color: white;
    margin: 20px;
    padding: 15px;
    font-size: 14px;
    padding-bottom:30px;
    display: inline-block;
    font-family: "Inconsolata";
    border: solid 1px rgb(220,220,220);
    border-radius: 3px;
    overflow: hidden;
}
.pos .pos-sale-ticket pre{
    font-family: "Inconsolata";
}
.pos .pos-sale-ticket .emph{
    font-size: 20px;
    margin:5px;
}
.pos .pos-sale-ticket table {
    width: 100%;
    border: 0;
    table-layout: fixed;
}
.pos .pos-sale-ticket table td {
    border: 0;
    word-wrap: break-word;
}

@page {
    margin: 0;
}

@media print {
    * {
        color: black !important;
    }
    body {
        margin: 0;
        color: white !important;
    }
    .oe_leftbar,
    .oe_loading,
    .pos .pos-topheader, 
    .pos .pos-leftpane, 
    .pos .keyboard_frame,
    .pos .receipt-screen header,
    .pos .receipt-screen .top-content,
    .pos .receipt-screen .centered-content .button {
        display: none !important;
    }
    .pos,
    .pos .pos-content,
    .pos .rightpane,
    .pos .screen, 
    .pos .window, 
    .pos .window .subwindow, 
    .pos .subwindow .subwindow-container{
        display: block;
        position: static;
        height: auto;
    }
    .pos{
        background: white !important;
    }
    .pos .rightpane {
        left: 0px !important;
        background-color: white;
    }
    .pos .receipt-screen {
        text-align: left;
    }
    .pos .receipt-screen .centered-content{
        position: static;
        border: none;
    }
    .pos .pos-receipt-container {
        text-align: left;
    }
    .pos-actionbar {
        display: none !important;
    }
    .debug-widget{
        display: none !important;
    }
    .pos *{
        text-shadow: none !important;
        box-shadow: none !important;
        background: transparent !important;
    }
    .pos .pos-sale-ticket{
        margin: 0;
        margin-left: auto !important;
        margin-right: auto !important;
        border: none !important;
        font-size: 13px !important;
        width: 266px !important;
    }
    .o_debug_manager {
        display: none !important;
    }
    .o_chat_window {
        display: none !important;
    }
}

/* d) The Scale screen */

.pos .scale-screen .product-price{
    font-size: 25px;
    margin: 16px;
    text-align: center;
    display: inline-block;
    width: 40%;
}
.pos .scale-screen .computed-price{
    font-size: 25px;
    display: inline-block;
    text-align: right;
    margin: 16px;
    margin-top: 0px;
    padding: 16px;
    background: white;
    width: 40%;
    border-radius: 3px;
    font-family: Inconsolata;
    font-weight: bold;
    text-shadow: 0px 2px 0px rgb(210,210,210);
    box-shadow: 0px 2px 0px rgb(225,225,225) inset;
    float: right;
}
.pos .scale-screen .buy-product{
    text-align: center;
    font-size: 32px;
    background: rgb(110,200,155);
    color: white;
    border-radius: 3px;
    padding: 16px;
    margin: 16px;
    cursor: pointer;
}

.pos .scale-screen .weight{
    text-align: right;
    margin: 16px;
    background: white;
    padding: 20px;
    padding-right: 30px;
    font-size: 56px;
    border-radius: 3px;
    font-family: Inconsolata;
    text-shadow: 0px 2px 0px rgb(210, 210, 210);
    box-shadow: 0px 2px 0px rgb(225,225,225) inset;
}


/* e) The Client List Screen */

.pos .clientlist-screen .client-list{
    font-size: 16px;
    width: 100%;
    line-height: 40px;
}
.pos .clientlist-screen .client-list th,
.pos .clientlist-screen .client-list td {
    padding: 0px 8px;
}
.pos .clientlist-screen .client-list tr{
    transition: all 150ms linear;
    background: rgb(230,230,230);
}
.pos .clientlist-screen .client-list thead > tr,
.pos .clientlist-screen .client-list tr:nth-child(even) {
    background: rgb(247,247,247);
}
.pos .clientlist-screen .client-list tr.highlight{
    transition: all 150ms linear;
    background: rgb(110,200,155) !important;
    color: white;
}
.pos .clientlist-screen .client-list tr.lowlight{
    transition: all 150ms linear;
    background: rgb(216, 238, 227);
}
.pos .clientlist-screen .client-list tr.lowlight:nth-child(even){
    transition: all 150ms linear;
    background: rgb(227, 246, 237);
}
.pos .clientlist-screen .client-details{
    padding: 16px;
    border-bottom: solid 5px rgb(110,200,155);
}
.pos .clientlist-screen .client-picture{
    height: 64px;
    width: 64px;
    border-radius: 32px;
    overflow: hidden;
    text-align: center;
    float: left;
    margin-right: 16px;
    background: white;
    position: relative;
}
.pos .clientlist-screen .client-picture > img {
    position: absolute;
    top: -9999px;
    bottom: -9999px;
    right: -9999px;
    left: -9999px;
    max-height: 64px;
    margin: auto;
}
.pos .clientlist-screen .client-picture > .fa {
    line-height: 64px;
    font-size: 32px;
}
.pos .clientlist-screen .client-picture .image-uploader {
    position: absolute;
    z-index: 1000;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    cursor: pointer;
}
.pos .clientlist-screen .client-name {
    font-size: 32px;
    line-height: 64px;
    margin-bottom:16px;
}
.pos .clientlist-screen .edit-buttons {
    position: absolute;
    right: 16px;
    top: 10px;
}
.pos .clientlist-screen .edit-buttons .button{
    display: inline-block;
    margin-left: 16px;
    color: rgb(128,128,128);
    cursor: pointer;
    font-size: 36px;
}
.pos .clientlist-screen .client-details-box{
    position: relative;
    font-size: 16px;
}
.pos .clientlist-screen .client-details-left{
    width: 50%;
    float: left;
}
.pos .clientlist-screen .client-details-right{
    width: 50%;
    float: right;
}
.pos .clientlist-screen .client-detail{
    line-height: 24px;
}
.pos .clientlist-screen .client-detail > .label{
    font-weight: bold;
    display: inline-block;
    width: 75px;
    text-align: right;
    margin-right: 8px;
}
.pos .clientlist-screen .client-details input,
.pos .clientlist-screen .client-details select
{
    padding: 4px;
    border-radius: 3px;
    border: solid 1px #cecbcb;
    margin-bottom: 4px;
    background: white;
    font-family: "Lato","Lucida Grande", Helvetica, Verdana, Arial;
    color: #555555;
    width: 340px;
    font-size: 14px;
    box-sizing: border-box;
}
.pos .clientlist-screen .client-details input.client-name {
    font-size: 24px;
    line-height: 24px;
    margin: 18px 6px;
    width: 340px;
}
.pos .clientlist-screen .client-detail > .empty{
    opacity: 0.3;
}
.pos .clientlist-screen .searchbox{
    right: auto;
    margin-left: -90px;
    margin-top:8px;
    left: 50%;
}
.pos .clientlist-screen .searchbox input{
    width: 120px;
}
.pos .clientlist-screen .button.new-customer {
    left: 50%;
    margin-left: 120px;
}


/*  ********* The OrderWidget  ********* */

.pos .order-container{
    position: absolute;
    top: 0px;
    width:100%;
    height: 100%;
    background: white;
}

.pos .order-scroller{
    width:100%;
    height:100%;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}

.pos .scrollable-y{
    overflow: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
}

.pos .order{
    background: white;
    padding-bottom: 8px;
    padding-top: 8px;
    font-size: 16px;
    text-align: left;
    max-width: 500px;
    -webkit-transform: translate3d(0,0,0);
}

.pos .order .order-empty {
    text-align: center;
    margin: 48px;
    color: #DDD;
}
.pos .order .order-empty .fa {
    font-size: 64px;
}
.pos .order .order-empty h1 {
    font-size: 20px;
}

.pos .order .summary{
    width:100%;
    text-align:right;
    font-weight: bold;
    margin-top:20px;
    margin-bottom:10px;
}
.pos .order .summary .line{
    float: right;
    margin-right:15px;
    margin-left: 15px;
    padding-top:5px;
    border-top: solid 2px;
    border-color:#777;
}
.pos .order .summary .total {
    font-size: 22px;
}
.pos .order .summary .line .subentry{
    font-size: 16px;
    font-weight: normal;
    text-align: center;
}
.pos .order .summary .line.empty{
    text-align: right;
    border-color:#BBB;
    color:#999;
}

.pos .order .summary .fidpoints{
    position: absolute;
    left: 20px;
    padding: 10px;
    color: #6EC89B;
    background: rgba(110, 200, 155, 0.17);
    border-radius: 3px;
}

.submit-kitchen-button {
    float: left;
    background: rgb(61, 235, 82);
    color: white;
    padding: 12px 20px;
    margin: 0px 15px;
    border-radius: 3px;
    cursor: pointer;
}

/*  ********* The OrderLineWidget  ********* */

.pos .order .orderline{
    width:100%;
    margin:0px;
    padding-top:3px;
    padding-bottom:10px;
    padding-left:15px;
    padding-right:15px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
        -ms-box-sizing: border-box;
            box-sizing: border-box;
    -webkit-transition: background 250ms ease-in-out;
       -moz-transition: background 250ms ease-in-out;
            transition: background 250ms ease-in-out;
}
.pos .order .orderline:active{
    background: rgba(140,143,183,0.05);
    -webkit-transition: background 50ms ease-in-out;
       -moz-transition: background 50ms ease-in-out;
            transition: background 50ms ease-in-out;
}
.pos .order .orderline.empty:active{
    background: transparent;
    cursor: default;
}

.pos .order .orderline.selected{
    background: rgba(140,143,183,0.2);
    -webkit-transition: background 250ms ease-in-out;
       -moz-transition: background 250ms ease-in-out;
            transition: background 250ms ease-in-out;
    cursor: default;
}
.pos .order .orderline .product-name{
    padding:0;
    display:inline-block;
    font-weight: bold;
    width:80%;
    overflow:hidden;
    text-overflow: ellipsis;
}
.pos .order .orderline .price{
    padding:0;
    font-weight: bold;
    float:right;
}
.pos .order .orderline .info-list{
    color: #888;
    margin-left:10px;
}
.pos .order .orderline .info-list em{
    color: #777;
    font-weight: bold;
    font-style:normal;
}

/*  ********* SplitBill ********* */

.splitbill-screen .order-info {
    text-align: center;
    margin-bottom:20px;
    padding: 20px 0px;
    font-size: 64px;
    color: #43996E;
    text-shadow: 0px 2px white, 0px 2px 2px rgba(0, 0, 0, 0.27);
    border-bottom: dashed 1px rgb(215,215,215);
}
.pos .splitbill-screen .order {
    background: white;
    padding-bottom:15px;
    padding-top:15px;
    margin-left:16px;
    margin-right:16px;
    margin-top:16px;
    margin-bottom:16px;
    font-size:16px;
    border-radius: 3px;
    border: solid 1px rgb(220,220,220);
    text-align: left;
    max-width: 500px;
    -webkit-transform: translate3d(0,0,0);
}
.splitbill-screen .order .orderline.selected{
    background: rgb(110,200,155);
    color: white;
    -webkit-transition: background 250ms ease-in-out;
       -moz-transition: background 250ms ease-in-out;
            transition: background 250ms ease-in-out;
    cursor: default;
}
.splitbill-screen .order .orderline.partially.selected{
    background: rgb(136, 214, 176);
}
.splitbill-screen .order .orderline.selected .info-list {
    color: white;
}
.splitbill-screen .order .orderline.selected .info-list em{
    color: white;
    font-size: 24px;
    vertical-align: top;
}
.paymentmethods {
    margin: 16px;
}
.paymentmethods .button {
    background: #e2e2e2;
    line-height: 74px;
    font-size: 14px;
    border: solid 1px rgb(202, 202, 202);
    border-top-width: 0px;
    cursor: pointer;
    text-align: center;
}
.paymentmethods .button:first-child {
    border-top-width: 1px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}
.paymentmethods .button:last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
}
.paymentmethods .button:active {
    background: black;
    border-color: black;
    color: white;
}
.paymentmethod .button.active {
    background: #6EC89B;
    color: white;
    border-color: #6EC89B;
}



/*  ********* The ActionBarWidget  ********* */

.pos .pos-actionbar{
    height: 105px;
    background: #f5f5f5;    /*#ebebeb;*/
    border-top: solid 1px #cecece;
    z-index:900;
}

.pos .pos-actionbar ul{
    list-style:  none;
}

.pos .pos-actionbar-button-list{
    height: 100%;
    margin: 0px;
    padding-left:3px;
    padding-right:3px;
    overflow:hidden;
}

.pos .pos-actionbar .button{
    width: 90px;
    height: 90px;
    text-align:center;
    margin:3px;
    margin-top:6px;
    float:left;

    font-size:   14px;
    font-weight: bold;

    cursor: pointer;

    border: 1px solid #cacaca;
    border-radius: 3px;

    background: #e2e2e2;
}
.pos .pos-actionbar .button .label{
    margin-top: 37px;
}
.pos .pos-actionbar .button .icon{
    margin-top: 10px;
}
.pos .pos-actionbar .button:active{
    color: white;
    background: #7f82ac;
    border: 1px solid #7f82ac;

    -webkit-transition-property: background, border;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-out;
}

.pos .pos-actionbar .button.disabled{
    opacity: 0.5;
}
.pos .pos-actionbar .button.disabled:active{
    border: 1px solid #cacaca;
    color: #555;
    cursor: default;

    background: #e2e2e2;
}

.pos .pos-actionbar .button.rightalign{
    float:right;
}
/*  ********* The Debug Widget  ********* */

.pos .debug-widget{
    z-index:100000;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 200px;
    font-size: 10px;
    
    background: rgba(0,0,0,0.82);
    color: white;
    padding-bottom: 10px;
    cursor: move;
    -webkit-transform: translate3d(0,0,0);
}
.pos .debug-widget .toggle{
    position: absolute;
    font-size: 16px;
    cursor:pointer;
    top:0px;
    right:0px;
    padding:10px;
    padding-right:15px;
}
.pos .debug-widget .content{
    overflow: hidden;
}
.pos .debug-widget h1{
    background:black;
    padding-top: 10px;
    padding-left: 10px;
    margin-top:0;
    margin-bottom:0;
}
.pos .debug-widget .category{
    background: black;
    padding-left: 10px;
    margin: 0px;
    font-weight: bold;
    padding-top:3px;
    padding-bottom:3px;
}
.pos .debug-widget .button{
    padding: 5px;
    padding-left: 15px;
    display: block;
    cursor:pointer;
}
.pos .debug-widget .button:active{
    background: rgba(96,21,177,0.45);
}
.pos .debug-widget input{
    margin-left:10px;
    margin-top:7px;
    padding: 4px;
    width: 180px;
    border: none;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    border-radius: 3px;
}
.pos .debug-widget .status{
    padding: 5px;
    padding-left: 15px;
    display: block;
    cursor:default;
}
.pos .debug-widget .status.on{
    background-color: #6cd11d;
}
.pos .debug-widget .event{
    padding: 5px;
    padding-left: 15px;
    display: block;
    cursor:default;
    background-color: #1E1E1E;
}

/*  ********* The PopupWidgets  ********* */

.pos .modal-dialog{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height:100%;
    background-color: rgba(0,0,0,0.5);
    z-index:1000;
}
.pos .modal-dialog .popup{
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    margin: auto;
    width:500px;
    height:400px;
    text-align:center;
    font-size:20px;
    font-weight:bold;
    background-color: #F0EEEE;
    border-radius: 3px;
    box-shadow: 0px 10px 20px rgba(0,0,0,0.4);
    z-index:1200;
    font-family: 'Lato';
    font-family: Lato;
}
.pos .modal-dialog .popup-confirm{
    height: 250px;
}
.pos .popup-confirm .body {
    overflow: auto;
    height: 120px;
}
.pos .popup .title {
    background: rgba(255,255,255,0.5);
    margin: 0;
    padding: 20px;
    border-radius: 3px 3px 0px 0px;
    border-bottom: solid 1px rgba(60,60,60,0.1);
}
.pos .popup .body {
    font-weight: normal;
    font-size: 18px;
    margin: 16px;
    margin-top: 20px;
}
.pos .popup .body.traceback {
    height: 238px;
    overflow: auto;
    font-size: 14px;
    white-space: pre-wrap;
    text-align: left;
    font-family: 'Inconsolata';
    -webkit-user-select: text;
       -moz-user-select: text;
            user-select: text;
}
.pos .popup .footer{
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
    height:60px;
    border-top: solid 1px rgba(60,60,60,0.1);
}
.pos .popup .button{
    float:right;
    width: 110px;
    height: 40px;
    line-height:40px;
    text-align:center;
    border-radius: 2px;
    margin-top:10px;
    margin-right:10px;

    font-size:   14px;
    font-weight: bold;

    cursor: pointer;

    border: solid 1px rgba(60,60,60,0.1);

    background: rgba(0,0,0,0.05);
}
.pos .popup .button.icon {
    width: 40px;
    font-size: 20px;
}
.pos .popup .button:active{
    color: white;
    background: black;
    border: 1px solid black;

    -webkit-transition-property: background, border;
    -webkit-transition-duration: 0.2s;
    -webkit-transition-timing-function: ease-out;
}


.pos .popup .button.big-left{
    position:absolute;
    top: 120px;
    left:40px;
    width: 180px;
    height: 180px;
    line-height:180px;
}

.pos .popup .button.big-right{
    position:absolute;
    top: 120px;
    right:40px;
    width: 180px;
    height: 180px;
    line-height:180px;
}
.pos .popup input,
.pos .popup-input {
    text-align: left;
    display: inline-block;
    overflow: hidden;
    background: white;
    min-height: 44px;
    font-family: "Lato";
    font-size: 20px;
    color: #444;
    padding: 10px;
    border-radius: 3px;
    border: none;
    box-shadow: 0px 0px 0px 1px rgb(220,220,220) inset;
    box-sizing: border-box;
    width: 80%;
}
.pos .popup .packlot-lines{
    overflow: auto;
    height: 250px;
    margin: 10px;
}
.pos .popup .packlot-line-input {
    margin: 3px;
}

.pos .popup-number .popup-input {
    text-align: center;
}
.pos .popup input:focus,
.pos .popup-input.active {
    outline: none;
    box-shadow: 0px 0px 0px 3px #6EC89B;
}
.pos .popup.popup-error {
    background-color: #F3BBBB;
    color: rgb(168, 89, 89);
    box-shadow: 0px 10px 20px rgba(92,51,51,0.4);
}
.pos .popup.popup-error .title {
    color: white;
    background: rgba(255, 76, 76, 0.5);
}
.pos .popup.popup-selection .selection {
    overflow-y: auto;
    max-height: 273px;
    font-size: 16px;
    width: auto;
    line-height: 50px;
    margin-top: -1px;
    border-top: solid 3px rgba(60,60,60,0.1);
    
}
.pos .popup.popup-selection .selection-item {
    width: auto;
    background: rgb(230,230,230);
    cursor: pointer;
    text-align: left;
    padding: 0px 16px;
}
.pos .popup.popup-selection .selection-item:nth-child(odd) {
    background: rgb(247,247,247);
}
.pos .popup.popup-selection .selection-item.selected {
    background: #6EC89B;
}
.pos .popup.popup-number {
    width: 300px;
    height: 450px;
}
.pos .footer.centered {
    text-align: center;
}
.pos .footer.centered .button {
    float: none;
    display: inline-block;
    margin-left: 3px;
    margin-right: 3px;
}
.pos .popup-numpad {
    margin: 12px auto;
    text-align: center;
    width: 254px;
}
.pos .popup-number .title,
.pos .popup-textinput .title
{
    margin-bottom: 20px;
}
.pos .popup-numpad .input-button,
.pos .popup-numpad .mode-button {
    background: none;
    height: 50px;
    width: 50px;
    padding: 0;
    border-radius: 25px;
    margin: 4px;
    vertical-align: top;
    color: #444;
}
.pos .popup-numpad .input-button:active,
.pos .popup-numpad .mode-button:active {
    background: #444;
    color: white;
    border-color: #444;
}

.pos .popup.popup-password {
    width: 254px;
}
.pos .popup-password .mode-button.add,
.pos .popup-password .input-button.dot {
    display: none;
}
.pos .popup-password .popup-numpad {
    width: 190px;
    text-align: left;
}
.pos .popup-password .popup-input {
    width: 70%;
 }

.pos .popup .body ul,
.pos .popup ul.body {
    text-align: left;
    margin-left: 1em;
}
.pos .popup .body li {
    text-indent: 1em;
}
.pos .popup .body li:before {
    content: '—';
    position: relative;
    font-size: 0.6em;
    left: -1em;
    bottom: 0.2em;
}


/*  ********* The Webkit Scrollbar  ********* */

.pos *::-webkit-scrollbar{
    width:  4px;
    height: 4px;
}
.pos *::-webkit-scrollbar-track{
    background: rgb(224,224,224);
    border-left: solid 1px rgb(200,200,200);
}
.pos *::-webkit-scrollbar-thumb{
    background: rgb(168,168,168);
    background: #393939;
    min-height: 30px;
}

.pos.big-scrollbars *::-webkit-scrollbar{
    width:  40px;
    height: 40px;
}
.pos.big-scrollbars *::-webkit-scrollbar-track{
    background: rgb(224,224,224);
    border-left: none;
}
.pos.big-scrollbars *::-webkit-scrollbar-thumb{
    background: rgb(168,168,168);
    min-height: 40px;
    border-radius: 3px;
}
.pos.big-scrollbars *::-webkit-scrollbar-button{
    width:  40px;
    height: 40px;
    border-radius: 3px;
    background: rgb(210,210,210);
    background-size: cover;
}
.pos.big-scrollbars *::-webkit-scrollbar-button:decrement{
    background-image: url('img/scroll-up.png');
}
.pos.big-scrollbars *::-webkit-scrollbar-button:increment{
    background-image: url('img/scroll-down.png');
}


/*  ********* Unsupported Browser Page ********* */

.pos .not-supported-browser{
    position: absolute;
    z-index: 100000;
    top: 0; bottom: 0; left: 0; right: 0;
    background: #2C2C2C;
}
.pos .not-supported-browser .message{
    width:600px;
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: #d3d3d3;
    font-size: 14px;
}
.pos .not-supported-browser img{
    border-collapse: separate;
}
</style>



// WEBPACK FOOTER //
// PointOfSales.vue?c5e12d24